/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(23);
	
	__webpack_require__(24);
	
	__webpack_require__(22);
	
	__webpack_require__(21);
	
	__webpack_require__(26);
	
	__webpack_require__(25);
	
	__webpack_require__(9);
	
	__webpack_require__(11);
	
	__webpack_require__(10);
	
	var _angular = __webpack_require__(7);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = _angular2.default.module('app', []);
	
	//import route from './config/route';
	//import './pages';
	
	
	app.directive('parallax', [function () {
	
	  return {
	    restrict: 'E',
	    templateUrl: 'pages/Parallax/parallax.html',
	    controllerAs: 'ParallaxCtrl',
	
	    link: function link($scope, element, attribute) {
	      this.$scope = $scope;
	
	      /* Hero height for full and half screen
	       ==================================================================================== */
	      var windowHeight = $(window).height();
	      $('.hero').height(windowHeight - 80);
	      $('.hero.mvisible').height(windowHeight - 136);
	
	      $(window).resize(function () {
	        var windowHeight = $(window).height();
	        $('.hero').height(windowHeight - 80);
	        $('.hero.mvisible').height(windowHeight - 136);
	      });
	
	      /* Responsive Menu - Expand / Collapse on Mobile
	       ==================================================================================== */
	      function recalculate_height() {
	        var nav_height = $(window).outerHeight();
	        $("#navigation").height(nav_height - 56);
	      }
	
	      $('#menu-toggle-wrapper').on('click', function (event) {
	        recalculate_height();
	        $(this).toggleClass('open');
	        $("body").toggleClass('open');
	        $('#navigation').slideToggle(200);
	        event.preventDefault();
	      });
	
	      $(window).resize(function () {
	        recalculate_height();
	      });
	    }
	  };
	}]);
	
	app.directive('fotky', ['$http', function ($http) {
	
	  return {
	    restrict: 'E',
	    templateUrl: 'pages/Fotky/fotky.html',
	    controllerAs: 'FotkyCtrl',
	
	    link: function link($scope, element, attribute) {
	
	      this.$scope = $scope;
	
	      $scope.album = 'spolocne';
	
	      $scope.fotos = [];
	
	      $scope.isSet = function (album) {
	        return $scope.album === album;
	      };
	
	      $scope.setAlbum = function (album) {
	        $scope.album = album;
	        $scope.getNewAlbum(album);
	      };
	
	      $scope.getNewAlbum = function (album) {
	
	        if (!album) {
	          album = this.album;
	        }
	
	        $http.get('json/fotky-' + album + '.json').then(function (res) {
	          $scope.fotos = res.data;
	        }).catch(function (response) {
	          console.error('chyba', response.status, response.data);
	        });
	      };
	
	      this.getGallery(element);
	      this.setDefaultAlbum();
	    },
	
	    setDefaultAlbum: function setDefaultAlbum() {
	      this.$scope.getNewAlbum(this.$scope.album);
	    },
	    getGallery: function getGallery(element) {
	
	      var elem = _angular2.default.element(document.querySelector('#wedding-gallery'));
	      _angular2.default.element(elem).magnificPopup({
	        delegate: '.block:not(.isotope-hidden) a',
	        type: 'image',
	        tLoading: 'Nahrávam fotku #%curr%...',
	        mainClass: 'mfp-img-mobile',
	        closeOnBgClick: false,
	        gallery: {
	          enabled: true,
	          navigateByImgClick: true,
	          preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
	        },
	        zoom: {
	          enabled: true,
	          duration: 300, // don't foget to change the duration also in CSS
	          opener: function opener(element) {
	            return element.parent().find('img');
	          }
	        },
	        image: {
	          cursor: null,
	          markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + '</div>' + '</div>' + '<div class="small-gallery-wrapper"><div class="small-gallery"></div></div>',
	          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
	          titleSrc: function titleSrc(item) {
	            return item.el.find('.portfolio-title').text(); // place .html() if you need to show categories too.
	          }
	        },
	        setActive: function setActive($gallery, ind) {
	
	          if (ind !== false) {
	            $gallery.find('img').removeClass('active');
	            $gallery.find('img:eq(' + ind + ')').addClass('active');
	          }
	
	          var active_left = $gallery.find('img.active').position().left;
	          var gall_width = $gallery.parent().width() / 2;
	          var active_width = $gallery.find('img.active').width() / 2;
	
	          $gallery.css('left', -(active_left - gall_width + active_width));
	        },
	        callbacks: {
	          open: function open() {
	            var $gallery = this.contentContainer.find('.small-gallery');
	            var magnificPopup = this;
	            $.each(this.st.items, function (i) {
	              var $img = $(this).parent().find('img');
	              $gallery.append($("<img />", {
	                src: $img.attr('src')
	              }).on('click', function () {
	                magnificPopup.goTo(i);
	              }));
	            });
	
	            this.content.find('img.mfp-img').load(function () {
	              magnificPopup.st.setActive($gallery, magnificPopup.currItem.index);
	            });
	          },
	          change: function change() {
	            var img = this.content.find('img.mfp-img');
	            var magnificPopup = this;
	            var $gallery = this.contentContainer.find('.small-gallery');
	
	            // Smanjujemo velicinu slika
	            img.css('max-height', parseFloat(img.css('max-height')) * 0.85);
	
	            if ($gallery.find('img').length) {
	              img.load(function () {
	                magnificPopup.st.setActive($gallery, magnificPopup.currItem.index);
	              });
	            }
	          },
	          resize: function resize() {
	
	            var img = this.content.parent().find('img.mfp-img');
	            var $gallery = this.contentContainer.find('.small-gallery');
	
	            img.css('max-height', parseFloat(img.css('max-height')) * 0.85);
	
	            if ($gallery.find('img').length) {
	              this.st.setActive(this.contentContainer.find('.small-gallery'), false);
	            }
	          }
	        }
	      });
	    }
	  };
	}]);
	
	app.directive('podakovanie', [function () {
	
	  return {
	    restrict: 'E',
	    templateUrl: 'pages/Podakovanie/podakovanie.html',
	    link: function link($scope, element, attribute) {
	      this.$scope = $scope;
	    }
	  };
	}]);
	
	app.directive('copyright', [function () {
	
	  return {
	    restrict: 'E',
	    templateUrl: 'pages/Copyright/copyright.html',
	    link: function link($scope, element, attribute) {
	      this.$scope = $scope;
	    }
	  };
	}]);
	
	app.directive('logo', [function () {
	
	  return {
	    restrict: 'E',
	    templateUrl: 'pages/Logo/logo.html',
	    link: function link($scope, element, attribute) {
	      this.$scope = $scope;
	    }
	  };
	}]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 1 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.12.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:17Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var deletedIds = [];
	
	var document = window.document;
	
	var slice = deletedIds.slice;
	
	var concat = deletedIds.concat;
	
	var push = deletedIds.push;
	
	var indexOf = deletedIds.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "1.12.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1, IE<9
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: deletedIds.sort,
		splice: deletedIds.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		// See test/unit/core.js for details concerning isFunction.
		// Since version 1.3, DOM methods and functions like alert
		// aren't supported. They return false on IE (#2968).
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray || function( obj ) {
			return jQuery.type( obj ) === "array";
		},
	
		isWindow: function( obj ) {
			/* jshint eqeqeq: false */
			return obj != null && obj == obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Must be an Object.
			// Because of IE, we also have to check the presence of the constructor property.
			// Make sure that DOM nodes and window objects don't pass through, as well
			if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			try {
	
				// Not own constructor property must be Object
				if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
					return false;
				}
			} catch ( e ) {
	
				// IE8,9 Will throw exceptions on certain host objects #9897
				return false;
			}
	
			// Support: IE<9
			// Handle iteration over inherited properties before own properties.
			if ( !support.ownFirst ) {
				for ( key in obj ) {
					return hasOwn.call( obj, key );
				}
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own.
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Workarounds based on findings by Jim Driscoll
		// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
		globalEval: function( data ) {
			if ( data && jQuery.trim( data ) ) {
	
				// We use execScript on Internet Explorer
				// We use an anonymous function so that context is window
				// rather than jQuery in Firefox
				( window.execScript || function( data ) {
					window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
				} )( data );
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1, IE<9
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			var len;
	
			if ( arr ) {
				if ( indexOf ) {
					return indexOf.call( arr, elem, i );
				}
	
				len = arr.length;
				i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;
	
				for ( ; i < len; i++ ) {
	
					// Skip accessing in sparse arrays
					if ( i in arr && arr[ i ] === elem ) {
						return i;
					}
				}
			}
	
			return -1;
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			while ( j < len ) {
				first[ i++ ] = second[ j++ ];
			}
	
			// Support: IE<9
			// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
			if ( len !== len ) {
				while ( second[ j ] !== undefined ) {
					first[ i++ ] = second[ j++ ];
				}
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var args, proxy, tmp;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: function() {
			return +( new Date() );
		},
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				ret = [],
				self = this,
				len = self.length;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// init accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector.charAt( 0 ) === "<" &&
					selector.charAt( selector.length - 1 ) === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if ( elem && elem.parentNode ) {
	
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if ( elem.id !== match[ 2 ] ) {
								return rootjQuery.find( selector );
							}
	
							// Otherwise, we inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof root.ready !== "undefined" ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var i,
				targets = jQuery( target, this ),
				len = targets.length;
	
			return this.filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within
		// the matched set of elements
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// index in selector
			if ( typeof elem === "string" ) {
				return jQuery.inArray( this[ 0 ], jQuery( elem ) );
			}
	
			// Locate the position of the desired element
			return jQuery.inArray(
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem, this );
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		do {
			cur = cur[ dir ];
		} while ( cur && cur.nodeType !== 1 );
	
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return jQuery.nodeName( elem, "iframe" ) ?
				elem.contentDocument || elem.contentWindow.document :
				jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var ret = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				ret = jQuery.filter( selector, ret );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					ret = jQuery.uniqueSort( ret );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					ret = ret.reverse();
				}
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = true;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
	
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// if we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * Clean-up method for dom ready events
	 */
	function detach() {
		if ( document.addEventListener ) {
			document.removeEventListener( "DOMContentLoaded", completed );
			window.removeEventListener( "load", completed );
	
		} else {
			document.detachEvent( "onreadystatechange", completed );
			window.detachEvent( "onload", completed );
		}
	}
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
	
		// readyState === "complete" is good enough for us to call the dom ready in oldIE
		if ( document.addEventListener ||
			window.event.type === "load" ||
			document.readyState === "complete" ) {
	
			detach();
			jQuery.ready();
		}
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE6-10
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			// Standards-based browsers support DOMContentLoaded
			} else if ( document.addEventListener ) {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
	
			// If IE event model is used
			} else {
	
				// Ensure firing before onload, maybe late but safe also for iframes
				document.attachEvent( "onreadystatechange", completed );
	
				// A fallback to window.onload, that will always work
				window.attachEvent( "onload", completed );
	
				// If IE and not a frame
				// continually check to see if the document is ready
				var top = false;
	
				try {
					top = window.frameElement == null && document.documentElement;
				} catch ( e ) {}
	
				if ( top && top.doScroll ) {
					( function doScrollCheck() {
						if ( !jQuery.isReady ) {
	
							try {
	
								// Use the trick by Diego Perini
								// http://javascript.nwbox.com/IEContentLoaded/
								top.doScroll( "left" );
							} catch ( e ) {
								return window.setTimeout( doScrollCheck, 50 );
							}
	
							// detach all dom ready events
							detach();
	
							// and execute any waiting functions
							jQuery.ready();
						}
					} )();
				}
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Support: IE<9
	// Iteration over object's inherited properties before its own
	var i;
	for ( i in jQuery( support ) ) {
		break;
	}
	support.ownFirst = i === "0";
	
	// Note: most support tests are defined in their respective modules.
	// false until the test is run
	support.inlineBlockNeedsLayout = false;
	
	// Execute ASAP in case we need to set body.style.zoom
	jQuery( function() {
	
		// Minified: var a,b,c,d
		var val, div, body, container;
	
		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
	
			// Return for frameset docs that don't have a body
			return;
		}
	
		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );
	
		if ( typeof div.style.zoom !== "undefined" ) {
	
			// Support: IE<8
			// Check if natively block-level elements act like inline-block
			// elements when setting their display to 'inline' and giving
			// them layout
			div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
	
			support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
			if ( val ) {
	
				// Prevent IE 6 from affecting layout for positioned elements #11048
				// Prevent IE from shrinking the body in IE 7 mode #12869
				// Support: IE<8
				body.style.zoom = 1;
			}
		}
	
		body.removeChild( container );
	} );
	
	
	( function() {
		var div = document.createElement( "div" );
	
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch ( e ) {
			support.deleteExpando = false;
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	var acceptData = function( elem ) {
		var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
			nodeType = +elem.nodeType || 1;
	
		// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
		return nodeType !== 1 && nodeType !== 9 ?
			false :
	
			// Nodes accept data unless otherwise specified; rejection can be conditional
			!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
	};
	
	
	
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
	
			var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				jQuery.data( elem, key, data );
	
			} else {
				data = undefined;
			}
		}
	
		return data;
	}
	
	// checks a cache object for emptiness
	function isEmptyDataObject( obj ) {
		var name;
		for ( name in obj ) {
	
			// if the public data object is empty, the private is still empty
			if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
				continue;
			}
			if ( name !== "toJSON" ) {
				return false;
			}
		}
	
		return true;
	}
	
	function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var ret, thisCache,
			internalKey = jQuery.expando,
	
			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,
	
			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,
	
			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;
	
		// Avoid doing any more work than we need to when trying to get data on an
		// object that has no data at all
		if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
			data === undefined && typeof name === "string" ) {
			return;
		}
	
		if ( !id ) {
	
			// Only DOM nodes need a new unique ID for each element since their data
			// ends up in the global cache
			if ( isNode ) {
				id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
			} else {
				id = internalKey;
			}
		}
	
		if ( !cache[ id ] ) {
	
			// Avoid exposing jQuery metadata on plain JS objects when the object
			// is serialized using JSON.stringify
			cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
		}
	
		// An object can be passed to jQuery.data instead of a key/value pair; this gets
		// shallow copied over onto the existing cache
		if ( typeof name === "object" || typeof name === "function" ) {
			if ( pvt ) {
				cache[ id ] = jQuery.extend( cache[ id ], name );
			} else {
				cache[ id ].data = jQuery.extend( cache[ id ].data, name );
			}
		}
	
		thisCache = cache[ id ];
	
		// jQuery data() is stored in a separate object inside the object's internal data
		// cache in order to avoid key collisions between internal data and user-defined
		// data.
		if ( !pvt ) {
			if ( !thisCache.data ) {
				thisCache.data = {};
			}
	
			thisCache = thisCache.data;
		}
	
		if ( data !== undefined ) {
			thisCache[ jQuery.camelCase( name ) ] = data;
		}
	
		// Check for both converted-to-camel and non-converted data property names
		// If a data property was specified
		if ( typeof name === "string" ) {
	
			// First Try to find as-is property data
			ret = thisCache[ name ];
	
			// Test for null|undefined property data
			if ( ret == null ) {
	
				// Try to find the camelCased property
				ret = thisCache[ jQuery.camelCase( name ) ];
			}
		} else {
			ret = thisCache;
		}
	
		return ret;
	}
	
	function internalRemoveData( elem, name, pvt ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var thisCache, i,
			isNode = elem.nodeType,
	
			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,
			id = isNode ? elem[ jQuery.expando ] : jQuery.expando;
	
		// If there is already no cache entry for this object, there is no
		// purpose in continuing
		if ( !cache[ id ] ) {
			return;
		}
	
		if ( name ) {
	
			thisCache = pvt ? cache[ id ] : cache[ id ].data;
	
			if ( thisCache ) {
	
				// Support array or space separated string names for data keys
				if ( !jQuery.isArray( name ) ) {
	
					// try the string as a key before any manipulation
					if ( name in thisCache ) {
						name = [ name ];
					} else {
	
						// split the camel cased version by spaces unless a key with the spaces exists
						name = jQuery.camelCase( name );
						if ( name in thisCache ) {
							name = [ name ];
						} else {
							name = name.split( " " );
						}
					}
				} else {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = name.concat( jQuery.map( name, jQuery.camelCase ) );
				}
	
				i = name.length;
				while ( i-- ) {
					delete thisCache[ name[ i ] ];
				}
	
				// If there is no data left in the cache, we want to continue
				// and let the cache object itself get destroyed
				if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
					return;
				}
			}
		}
	
		// See jQuery.data for more information
		if ( !pvt ) {
			delete cache[ id ].data;
	
			// Don't destroy the parent cache unless the internal data object
			// had been the only thing left in it
			if ( !isEmptyDataObject( cache[ id ] ) ) {
				return;
			}
		}
	
		// Destroy the cache
		if ( isNode ) {
			jQuery.cleanData( [ elem ], true );
	
		// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
		/* jshint eqeqeq: false */
		} else if ( support.deleteExpando || cache != cache.window ) {
			/* jshint eqeqeq: true */
			delete cache[ id ];
	
		// When all else fails, undefined
		} else {
			cache[ id ] = undefined;
		}
	}
	
	jQuery.extend( {
		cache: {},
	
		// The following elements (space-suffixed to avoid Object.prototype collisions)
		// throw uncatchable exceptions if you attempt to set expando properties
		noData: {
			"applet ": true,
			"embed ": true,
	
			// ...but Flash objects (which have this classid) *can* handle expandos
			"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
		},
	
		hasData: function( elem ) {
			elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
			return !!elem && !isEmptyDataObject( elem );
		},
	
		data: function( elem, name, data ) {
			return internalData( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			return internalRemoveData( elem, name );
		},
	
		// For internal use only.
		_data: function( elem, name, data ) {
			return internalData( elem, name, data, true );
		},
	
		_removeData: function( elem, name ) {
			return internalRemoveData( elem, name, true );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Special expections of .data basically thwart jQuery.access,
			// so implement the relevant behavior ourselves
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = jQuery.data( elem );
	
					if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						jQuery._data( elem, "parsedAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					jQuery.data( this, key );
				} );
			}
	
			return arguments.length > 1 ?
	
				// Sets one value
				this.each( function() {
					jQuery.data( this, key, value );
				} ) :
	
				// Gets one value
				// Try to fetch any internally stored data first
				elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
		},
	
		removeData: function( key ) {
			return this.each( function() {
				jQuery.removeData( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = jQuery._data( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// not intended for public consumption - generates a queueHooks object,
		// or returns the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return jQuery._data( elem, key ) || jQuery._data( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					jQuery._removeData( elem, type + "queue" );
					jQuery._removeData( elem, key );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = jQuery._data( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	
	
	( function() {
		var shrinkWrapBlocksVal;
	
		support.shrinkWrapBlocks = function() {
			if ( shrinkWrapBlocksVal != null ) {
				return shrinkWrapBlocksVal;
			}
	
			// Will be changed later if needed.
			shrinkWrapBlocksVal = false;
	
			// Minified: var b,c,d
			var div, body, container;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
	
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			// Support: IE6
			// Check if elements with layout shrink-wrap their children
			if ( typeof div.style.zoom !== "undefined" ) {
	
				// Reset CSS: box-sizing; display; margin; border
				div.style.cssText =
	
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;" +
					"padding:1px;width:1px;zoom:1";
				div.appendChild( document.createElement( "div" ) ).style.width = "5px";
				shrinkWrapBlocksVal = div.offsetWidth !== 3;
			}
	
			body.removeChild( container );
	
			return shrinkWrapBlocksVal;
		};
	
	} )();
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			length = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < length; i++ ) {
					fn(
						elems[ i ],
						key,
						raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				length ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	var rleadingWhitespace = ( /^\s+/ );
	
	var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
			"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
			"mark|meter|nav|output|picture|progress|section|summary|template|time|video";
	
	
	
	function createSafeFragment( document ) {
		var list = nodeNames.split( "|" ),
			safeFrag = document.createDocumentFragment();
	
		if ( safeFrag.createElement ) {
			while ( list.length ) {
				safeFrag.createElement(
					list.pop()
				);
			}
		}
		return safeFrag;
	}
	
	
	( function() {
		var div = document.createElement( "div" ),
			fragment = document.createDocumentFragment(),
			input = document.createElement( "input" );
	
		// Setup
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
		// IE strips leading whitespace when .innerHTML is used
		support.leadingWhitespace = div.firstChild.nodeType === 3;
	
		// Make sure that tbody elements aren't automatically inserted
		// IE will insert them into empty tables
		support.tbody = !div.getElementsByTagName( "tbody" ).length;
	
		// Make sure that link elements get serialized correctly by innerHTML
		// This requires a wrapper element in IE
		support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;
	
		// Makes sure cloning an html5 element does not cause problems
		// Where outerHTML is undefined, this still works
		support.html5Clone =
			document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";
	
		// Check if a disconnected checkbox will retain its checked
		// value of true after appended to the DOM (IE6/7)
		input.type = "checkbox";
		input.checked = true;
		fragment.appendChild( input );
		support.appendChecked = input.checked;
	
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		// Support: IE6-IE11+
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// #11217 - WebKit loses check when the name is after the checked attribute
		fragment.appendChild( div );
	
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input = document.createElement( "input" );
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
		// old WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<9
		// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
		support.noCloneEvent = !!div.addEventListener;
	
		// Support: IE<9
		// Since attributes and properties are the same in IE,
		// cleanData must set properties to undefined rather than use removeAttribute
		div[ jQuery.expando ] = 1;
		support.attributes = !div.getAttribute( jQuery.expando );
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
		legend: [ 1, "<fieldset>", "</fieldset>" ],
		area: [ 1, "<map>", "</map>" ],
	
		// Support: IE8
		param: [ 1, "<object>", "</object>" ],
		thead: [ 1, "<table>", "</table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
		// unless wrapped in a div with non-breaking characters in front of it.
		_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
	};
	
	// Support: IE8-IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
		var elems, elem,
			i = 0,
			found = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
					undefined;
	
		if ( !found ) {
			for ( found = [], elems = context.childNodes || context;
				( elem = elems[ i ] ) != null;
				i++
			) {
				if ( !tag || jQuery.nodeName( elem, tag ) ) {
					found.push( elem );
				} else {
					jQuery.merge( found, getAll( elem, tag ) );
				}
			}
		}
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], found ) :
			found;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var elem,
			i = 0;
		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			jQuery._data(
				elem,
				"globalEval",
				!refElements || jQuery._data( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/,
		rtbody = /<tbody/i;
	
	function fixDefaultChecked( elem ) {
		if ( rcheckableType.test( elem.type ) ) {
			elem.defaultChecked = elem.checked;
		}
	}
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var j, elem, contains,
			tmp, tag, tbody, wrap,
			l = elems.length,
	
			// Ensure a safe fragment
			safe = createSafeFragment( context ),
	
			nodes = [],
			i = 0;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || safe.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
	
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Manually add leading whitespace removed by IE
					if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
						nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
					}
	
					// Remove IE's autoinserted <tbody> from table fragments
					if ( !support.tbody ) {
	
						// String was a <table>, *may* have spurious <tbody>
						elem = tag === "table" && !rtbody.test( elem ) ?
							tmp.firstChild :
	
							// String was a bare <thead> or <tfoot>
							wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
								tmp :
								0;
	
						j = elem && elem.childNodes.length;
						while ( j-- ) {
							if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
								!tbody.childNodes.length ) {
	
								elem.removeChild( tbody );
							}
						}
					}
	
					jQuery.merge( nodes, tmp.childNodes );
	
					// Fix #12392 for WebKit and IE > 9
					tmp.textContent = "";
	
					// Fix #12392 for oldIE
					while ( tmp.firstChild ) {
						tmp.removeChild( tmp.firstChild );
					}
	
					// Remember the top-level container for proper cleanup
					tmp = safe.lastChild;
				}
			}
		}
	
		// Fix #11356: Clear elements from fragment
		if ( tmp ) {
			safe.removeChild( tmp );
		}
	
		// Reset defaultChecked for any radios and checkboxes
		// about to be appended to the DOM in IE 6/7 (#8060)
		if ( !support.appendChecked ) {
			jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
		}
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
	
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( safe.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		tmp = null;
	
		return safe;
	}
	
	
	( function() {
		var i, eventName,
			div = document.createElement( "div" );
	
		// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
		for ( i in { submit: true, change: true, focusin: true } ) {
			eventName = "on" + i;
	
			if ( !( support[ i ] = eventName in window ) ) {
	
				// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
				div.setAttribute( eventName, "t" );
				support[ i ] = div.attributes[ eventName ].expando === false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	
	
	var rformElems = /^(?:input|select|textarea)$/i,
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
			var tmp, events, t, handleObjIn,
				special, eventHandle, handleObj,
				handlers, type, namespaces, origType,
				elemData = jQuery._data( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" &&
						( !e || jQuery.event.triggered !== e.type ) ?
						jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
						undefined;
				};
	
				// Add elem as a property of the handle fn to prevent a memory leak
				// with IE non-native events
				eventHandle.elem = elem;
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener/attachEvent if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						// Bind the global event handler to the element
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
	
						} else if ( elem.attachEvent ) {
							elem.attachEvent( "on" + type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
			// Nullify elem to prevent memory leaks in IE
			elem = null;
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
			var j, handleObj, tmp,
				origCount, t, events,
				special, handlers, type,
				namespaces, origType,
				elemData = jQuery.hasData( elem ) && jQuery._data( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
	
				// removeData also checks for emptiness and clears the expando if empty
				// so use it instead of delete
				jQuery._removeData( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
			var handle, ontype, cur,
				bubbleType, special, tmp, i,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
					jQuery._data( cur, "handle" );
	
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if (
					( !special._default ||
					 special._default.apply( eventPath.pop(), data ) === false
					) && acceptData( elem )
				) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Can't use an .isFunction() check here because IE6/7 fails that test.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						try {
							elem[ type ]();
						} catch ( e ) {
	
							// IE<9 dies on focus/blur to hidden element (#1486,#12518)
							// only reproducible on winXP IE8 native, not IE9 in IE8 mode
						}
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				/* jshint eqeqeq: false */
				for ( ; cur != this; cur = cur.parentNode || this ) {
					/* jshint eqeqeq: true */
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: IE<9
			// Fix target property (#1925)
			if ( !event.target ) {
				event.target = originalEvent.srcElement || document;
			}
	
			// Support: Safari 6-8+
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			// Support: IE<9
			// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
			event.metaKey = !!event.metaKey;
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
				"pageX pageY screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var body, eventDoc, doc,
					button = original.button,
					fromElement = original.fromElement;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add relatedTarget, if necessary
				if ( !event.relatedTarget && fromElement ) {
					event.relatedTarget = fromElement === event.target ?
						original.toElement :
						fromElement;
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						try {
							this.focus();
							return false;
						} catch ( e ) {
	
							// Support: IE<9
							// If we error on focus to hidden element (#1486, #12518),
							// let .trigger() run the handlers
						}
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		// Piggyback on a donor event to simulate a different one
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// Guard for simulated events was moved to jQuery.event.stopPropagation function
					// since `originalEvent` should point to the original event for the
					// constancy with other events and for more focused logic
				}
			);
	
			jQuery.event.trigger( e, null, elem );
	
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = document.removeEventListener ?
		function( elem, type, handle ) {
	
			// This "if" is needed for plain objects
			if ( elem.removeEventListener ) {
				elem.removeEventListener( type, handle );
			}
		} :
		function( elem, type, handle ) {
			var name = "on" + type;
	
			if ( elem.detachEvent ) {
	
				// #8545, #7054, preventing memory leaks for custom events in IE6-8
				// detachEvent needed property on element, by name of that event,
				// to properly expose it to GC
				if ( typeof elem[ name ] === "undefined" ) {
					elem[ name ] = null;
				}
	
				elem.detachEvent( name, handle );
			}
		};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: IE < 9, Android < 4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
			if ( !e ) {
				return;
			}
	
			// If preventDefault exists, run it on the original event
			if ( e.preventDefault ) {
				e.preventDefault();
	
			// Support: IE
			// Otherwise set the returnValue property of the original event to false
			} else {
				e.returnValue = false;
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( !e || this.isSimulated ) {
				return;
			}
	
			// If stopPropagation exists, run it on the original event
			if ( e.stopPropagation ) {
				e.stopPropagation();
			}
	
			// Support: IE
			// Set the cancelBubble property of the original event to true
			e.cancelBubble = true;
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	// IE submit delegation
	if ( !support.submit ) {
	
		jQuery.event.special.submit = {
			setup: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Lazy-add a submit handler when a descendant form may potentially be submitted
				jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
	
					// Node name check avoids a VML-related crash in IE (#9807)
					var elem = e.target,
						form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?
	
							// Support: IE <=8
							// We use jQuery.prop instead of elem.form
							// to allow fixing the IE8 delegated submit issue (gh-2332)
							// by 3rd party polyfills/workarounds.
							jQuery.prop( elem, "form" ) :
							undefined;
	
					if ( form && !jQuery._data( form, "submit" ) ) {
						jQuery.event.add( form, "submit._submit", function( event ) {
							event._submitBubble = true;
						} );
						jQuery._data( form, "submit", true );
					}
				} );
	
				// return undefined since we don't need an event listener
			},
	
			postDispatch: function( event ) {
	
				// If form was submitted by the user, bubble the event up the tree
				if ( event._submitBubble ) {
					delete event._submitBubble;
					if ( this.parentNode && !event.isTrigger ) {
						jQuery.event.simulate( "submit", this.parentNode, event );
					}
				}
			},
	
			teardown: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
				jQuery.event.remove( this, "._submit" );
			}
		};
	}
	
	// IE change delegation and checkbox/radio fix
	if ( !support.change ) {
	
		jQuery.event.special.change = {
	
			setup: function() {
	
				if ( rformElems.test( this.nodeName ) ) {
	
					// IE doesn't fire change on a check/radio until blur; trigger it on click
					// after a propertychange. Eat the blur-change in special.change.handle.
					// This still fires onchange a second time for check/radio after blur.
					if ( this.type === "checkbox" || this.type === "radio" ) {
						jQuery.event.add( this, "propertychange._change", function( event ) {
							if ( event.originalEvent.propertyName === "checked" ) {
								this._justChanged = true;
							}
						} );
						jQuery.event.add( this, "click._change", function( event ) {
							if ( this._justChanged && !event.isTrigger ) {
								this._justChanged = false;
							}
	
							// Allow triggered, simulated change events (#11500)
							jQuery.event.simulate( "change", this, event );
						} );
					}
					return false;
				}
	
				// Delegated event; lazy-add a change handler on descendant inputs
				jQuery.event.add( this, "beforeactivate._change", function( e ) {
					var elem = e.target;
	
					if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
						jQuery.event.add( elem, "change._change", function( event ) {
							if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
								jQuery.event.simulate( "change", this.parentNode, event );
							}
						} );
						jQuery._data( elem, "change", true );
					}
				} );
			},
	
			handle: function( event ) {
				var elem = event.target;
	
				// Swallow native change events from checkbox/radio, we already triggered them above
				if ( this !== elem || event.isSimulated || event.isTrigger ||
					( elem.type !== "radio" && elem.type !== "checkbox" ) ) {
	
					return event.handleObj.handler.apply( this, arguments );
				}
			},
	
			teardown: function() {
				jQuery.event.remove( this, "._change" );
	
				return !rformElems.test( this.nodeName );
			}
		};
	}
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						jQuery._removeData( doc, fix );
					} else {
						jQuery._data( doc, fix, attaches );
					}
				}
			};
		} );
	}
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		},
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
		rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
		safeFragment = createSafeFragment( document ),
		fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );
	
	// Support: IE<8
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
			return;
		}
	
		var type, i, l,
			oldData = jQuery._data( src ),
			curData = jQuery._data( dest, oldData ),
			events = oldData.events;
	
		if ( events ) {
			delete curData.handle;
			curData.events = {};
	
			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	
		// make the cloned public data object a copy from the original
		if ( curData.data ) {
			curData.data = jQuery.extend( {}, curData.data );
		}
	}
	
	function fixCloneNodeIssues( src, dest ) {
		var nodeName, e, data;
	
		// We do not need to do anything for non-Elements
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		nodeName = dest.nodeName.toLowerCase();
	
		// IE6-8 copies events bound via attachEvent when using cloneNode.
		if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
			data = jQuery._data( dest );
	
			for ( e in data.events ) {
				jQuery.removeEvent( dest, e, data.handle );
			}
	
			// Event data gets referenced instead of copied if the expando gets copied too
			dest.removeAttribute( jQuery.expando );
		}
	
		// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
		if ( nodeName === "script" && dest.text !== src.text ) {
			disableScript( dest ).text = src.text;
			restoreScript( dest );
	
		// IE6-10 improperly clones children of object elements using classid.
		// IE10 throws NoModificationAllowedError if parent is null, #12132.
		} else if ( nodeName === "object" ) {
			if ( dest.parentNode ) {
				dest.outerHTML = src.outerHTML;
			}
	
			// This path appears unavoidable for IE9. When cloning an object
			// element in IE9, the outerHTML strategy above is not sufficient.
			// If the src has innerHTML and the destination does not,
			// copy the src.innerHTML into the dest.innerHTML. #10324
			if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
				dest.innerHTML = src.innerHTML;
			}
	
		} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
	
			// IE6-8 fails to persist the checked state of a cloned checkbox
			// or radio button. Worse, IE6-7 fail to give the cloned element
			// a checked appearance if the defaultChecked value isn't also set
	
			dest.defaultChecked = dest.checked = src.checked;
	
			// IE6-7 get confused and end up setting the value of a cloned
			// checkbox/radio button to an empty string instead of "on"
			if ( dest.value !== src.value ) {
				dest.value = src.value;
			}
	
		// IE6-8 fails to return the selected option to the default selected
		// state when cloning options
		} else if ( nodeName === "option" ) {
			dest.defaultSelected = dest.selected = src.defaultSelected;
	
		// IE6-8 fails to set the defaultValue to the correct value when
		// cloning other types of input fields
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var first, node, hasScripts,
			scripts, doc, fragment,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!jQuery._data( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval(
									( node.text || node.textContent || node.innerHTML || "" )
										.replace( rcleanScript, "" )
								);
							}
						}
					}
				}
	
				// Fix #11809: Avoid leaking memory
				fragment = first = null;
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			elems = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = elems[ i ] ) != null; i++ ) {
	
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var destElements, node, clone, i, srcElements,
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
				!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
	
				clone = elem.cloneNode( true );
	
			// IE<=8 does not properly clone detached, unknown element nodes
			} else {
				fragmentDiv.innerHTML = elem.outerHTML;
				fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
			}
	
			if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
					( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				// Fix all IE cloning issues
				for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {
	
					// Ensure that the destination node is not null; Fixes #9587
					if ( destElements[ i ] ) {
						fixCloneNodeIssues( node, destElements[ i ] );
					}
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
						cloneCopyEvent( node, destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			destElements = srcElements = node = null;
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems, /* internal */ forceAcceptData ) {
			var elem, type, id, data,
				i = 0,
				internalKey = jQuery.expando,
				cache = jQuery.cache,
				attributes = support.attributes,
				special = jQuery.event.special;
	
			for ( ; ( elem = elems[ i ] ) != null; i++ ) {
				if ( forceAcceptData || acceptData( elem ) ) {
	
					id = elem[ internalKey ];
					data = id && cache[ id ];
	
					if ( data ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Remove cache only if it was not already removed by jQuery.event.remove
						if ( cache[ id ] ) {
	
							delete cache[ id ];
	
							// Support: IE<9
							// IE does not allow us to delete expando properties from nodes
							// IE creates expando attributes along with the property
							// IE does not have a removeAttribute function on Document nodes
							if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
								elem.removeAttribute( internalKey );
	
							// Webkit & Blink performance suffers when deleting properties
							// from DOM nodes, so set to undefined instead
							// https://code.google.com/p/chromium/issues/detail?id=378607
							} else {
								elem[ internalKey ] = undefined;
							}
	
							deletedIds.push( id );
						}
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().append(
						( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
					);
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
	
				// Remove element nodes and prevent memory leaks
				if ( elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem, false ) );
				}
	
				// Remove any remaining nodes
				while ( elem.firstChild ) {
					elem.removeChild( elem.firstChild );
				}
	
				// If this is a select, ensure that it displays empty (#12336)
				// Support: IE<9
				if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
					elem.options.length = 0;
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined ) {
					return elem.nodeType === 1 ?
						elem.innerHTML.replace( rinlinejQuery, "" ) :
						undefined;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
					( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
	
							// Remove element nodes and prevent memory leaks
							elem = this[ i ] || {};
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				i = 0,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
			reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		div.style.cssText = "float:left;opacity:.5";
	
		// Support: IE<9
		// Make sure that element opacity exists (as opposed to filter)
		support.opacity = div.style.opacity === "0.5";
	
		// Verify style float existence
		// (IE uses styleFloat instead of cssFloat)
		support.cssFloat = !!div.style.cssFloat;
	
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container = document.createElement( "div" );
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		div.innerHTML = "";
		container.appendChild( div );
	
		// Support: Firefox<29, Android 2.3
		// Vendor-prefix box-sizing
		support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
			div.style.WebkitBoxSizing === "";
	
		jQuery.extend( support, {
			reliableHiddenOffsets: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableHiddenOffsetsVal;
			},
	
			boxSizingReliable: function() {
	
				// We're checking for pixelPositionVal here instead of boxSizingReliableVal
				// since that compresses better and they're computed together anyway.
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
	
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
	
			pixelPosition: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelPositionVal;
			},
	
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginRightVal;
			},
	
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			}
		} );
	
		function computeStyleTests() {
			var contents, divStyle,
				documentElement = document.documentElement;
	
			// Setup
			documentElement.appendChild( container );
	
			div.style.cssText =
	
				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
	
			// Support: IE<9
			// Assume reasonable values in the absence of getComputedStyle
			pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
			pixelMarginRightVal = reliableMarginRightVal = true;
	
			// Check for getComputedStyle so that this code is not run in IE<9.
			if ( window.getComputedStyle ) {
				divStyle = window.getComputedStyle( div );
				pixelPositionVal = ( divStyle || {} ).top !== "1%";
				reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
				boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";
	
				// Support: Android 4.0 - 4.3 only
				// Some styles come back with percentage values, even though they shouldn't
				div.style.marginRight = "50%";
				pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";
	
				// Support: Android 2.3 only
				// Div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				contents = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				contents.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				contents.style.marginRight = contents.style.width = "0";
				div.style.width = "1px";
	
				reliableMarginRightVal =
					!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );
	
				div.removeChild( contents );
			}
	
			// Support: IE6-8
			// First check that getClientRects works as expected
			// Check if table cells still have offsetWidth/Height when they are set
			// to display:none and there are still other visible table cells in a
			// table row; if so, offsetWidth/Height are not reliable for use when
			// determining if an element has been hidden directly using
			// display:none (it is still safe to use offsets if a parent element is
			// hidden; don safety goggles and see bug #4512 for more information).
			div.style.display = "none";
			reliableHiddenOffsetsVal = div.getClientRects().length === 0;
			if ( reliableHiddenOffsetsVal ) {
				div.style.display = "";
				div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
				div.childNodes[ 0 ].style.borderCollapse = "separate";
				contents = div.getElementsByTagName( "td" );
				contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				if ( reliableHiddenOffsetsVal ) {
					contents[ 0 ].style.display = "";
					contents[ 1 ].style.display = "none";
					reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				}
			}
	
			// Teardown
			documentElement.removeChild( container );
		}
	
	} )();
	
	
	var getStyles, curCSS,
		rposition = /^(top|right|bottom|left)$/;
	
	if ( window.getComputedStyle ) {
		getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
		curCSS = function( elem, name, computed ) {
			var width, minWidth, maxWidth, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
	
			// getPropertyValue is only needed for .css('filter') in IE9, see #12537
			ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
			// Support: Opera 12.1x only
			// Fall back to style even without computed
			// computed is undefined for elems on document fragments
			if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			if ( computed ) {
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Chrome < 17 and Safari 5.0 uses "computed value"
				// instead of "used value" for margin-right
				// Safari 5.1.7 (at least) returns percentage for a larger set of values,
				// but width seems to be reliably pixels
				// this is against the CSSOM draft spec:
				// http://dev.w3.org/csswg/cssom/#resolved-values
				if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "";
		};
	} else if ( documentElement.currentStyle ) {
		getStyles = function( elem ) {
			return elem.currentStyle;
		};
	
		curCSS = function( elem, name, computed ) {
			var left, rs, rsLeft, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
			ret = computed ? computed[ name ] : undefined;
	
			// Avoid setting ret to empty string here
			// so we don't default to auto
			if ( ret == null && style && style[ name ] ) {
				ret = style[ name ];
			}
	
			// From the awesome hack by Dean Edwards
			// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
			// If we're not dealing with a regular pixel number
			// but a number that has a weird ending, we need to convert it to pixels
			// but not position css attributes, as those are
			// proportional to the parent element instead
			// and we can't measure the parent instead because it
			// might trigger a "stacking dolls" problem
			if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {
	
				// Remember the original values
				left = style.left;
				rs = elem.runtimeStyle;
				rsLeft = rs && rs.left;
	
				// Put in the new values to get a computed value out
				if ( rsLeft ) {
					rs.left = elem.currentStyle.left;
				}
				style.left = name === "fontSize" ? "1em" : ret;
				ret = style.pixelLeft + "px";
	
				// Revert the changed values
				style.left = left;
				if ( rsLeft ) {
					rs.left = rsLeft;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "" || "auto";
		};
	}
	
	
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
			ralpha = /alpha\([^)]*\)/i,
		ropacity = /opacity\s*=\s*([^)]*)/i,
	
		// swappable if display is none or starts with table except
		// "table", "table-cell", or "table-caption"
		// see here for display values:
		// https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	
	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// check for vendor prefixed names
		var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = jQuery._data( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] =
						jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display && display !== "none" || !hidden ) {
					jQuery._data(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// at this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// at this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// at this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = support.boxSizing &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// we need the check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
	
			// normalize float css property
			"float": support.cssFloat ? "cssFloat" : "styleFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set. See: #7116
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
				// but it would mean to define eight
				// (for every problematic property) identical functions
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					// Support: IE
					// Swallow errors from 'invalid' CSS values (#5509)
					try {
						style[ name ] = value;
					} catch ( e ) {}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var num, val, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			//convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Return, converting to number if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// certain elements can have dimension info if we invisibly show them
					// however, it must have a current display style that would benefit from this
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						support.boxSizing &&
							jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	} );
	
	if ( !support.opacity ) {
		jQuery.cssHooks.opacity = {
			get: function( elem, computed ) {
	
				// IE uses filters for opacity
				return ropacity.test( ( computed && elem.currentStyle ?
					elem.currentStyle.filter :
					elem.style.filter ) || "" ) ?
						( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
						computed ? "1" : "";
			},
	
			set: function( elem, value ) {
				var style = elem.style,
					currentStyle = elem.currentStyle,
					opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
					filter = currentStyle && currentStyle.filter || style.filter || "";
	
				// IE has trouble with opacity if it does not have layout
				// Force it by setting the zoom level
				style.zoom = 1;
	
				// if setting opacity to 1, and no other filters exist -
				// attempt to remove filter attribute #6652
				// if value === "", then remove inline opacity #12685
				if ( ( value >= 1 || value === "" ) &&
						jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
						style.removeAttribute ) {
	
					// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
					// if "filter:" is present at all, clearType is disabled, we want to avoid this
					// style.removeAttribute is IE Only, but so apparently is this code path...
					style.removeAttribute( "filter" );
	
					// if there is no filter style applied in a css rule
					// or unset inline opacity, we are done
					if ( value === "" || currentStyle && !currentStyle.filter ) {
						return;
					}
				}
	
				// otherwise, set new filter values
				style.filter = ralpha.test( filter ) ?
					filter.replace( ralpha, opacity ) :
					filter + " " + opacity;
			}
		};
	}
	
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return (
					parseFloat( curCSS( elem, "marginLeft" ) ) ||
	
					// Support: IE<=11+
					// Running getBoundingClientRect on a disconnected node in IE throws an error
					// Support: IE8 only
					// getClientRects() errors on disconnected elems
					( jQuery.contains( elem.ownerDocument, elem ) ?
						elem.getBoundingClientRect().left -
							swap( elem, { marginLeft: 0 }, function() {
								return elem.getBoundingClientRect().left;
							} ) :
						0
					)
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails
				// so, simple values such as "10px" are parsed to Float.
				// complex values such as "rotate(1rad)" are returned as is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// use step hook for back compat - use cssHook if its there - use .style if its
				// available and use plain properties where available
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9
	// Panic based approach to setting things on disconnected nodes
	
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			attrs = { height: type },
			i = 0;
	
		// if we include width, step value is 1 to do all cssExpand values,
		// if we don't include width, step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// we're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = jQuery._data( elem, "fxshow" );
	
		// handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// doing this makes sure that the complete handler will be called
				// before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE does not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
	
				// inline-level elements accept inline-block;
				// block-level elements need to be inline with layout
				if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
					style.display = "inline-block";
				} else {
					style.zoom = 1;
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			if ( !support.shrinkWrapBlocks() ) {
				anim.always( function() {
					style.overflow = opts.overflow[ 0 ];
					style.overflowX = opts.overflow[ 1 ];
					style.overflowY = opts.overflow[ 2 ];
				} );
			}
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = jQuery._data( elem, "fxshow", {} );
			}
	
			// store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
				jQuery._removeData( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// not quite $.extend, this wont overwrite keys already present.
				// also - reusing 'index' from above because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// if we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// resolve when we played the last frame
					// otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || jQuery._data( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = jQuery._data( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// start the next in the queue if the last step wasn't forced
				// timers currently will call their complete callbacks, which will dequeue
				// but only if they were gotoEnd
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = jQuery._data( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// enable finishing flag on private data
				data.finish = true;
	
				// empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			timers = jQuery.timers,
			i = 0;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var a,
			input = document.createElement( "input" ),
			div = document.createElement( "div" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		// Setup
		div = document.createElement( "div" );
		div.setAttribute( "className", "t" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// Support: Windows Web Apps (WWA)
		// `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "checkbox" );
		div.appendChild( input );
	
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// First batch of tests.
		a.style.cssText = "top:1px";
	
		// Test setAttribute on camelCase class.
		// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
		support.getSetAttribute = div.className !== "t";
	
		// Get the style information from getAttribute
		// (IE uses .cssText instead)
		support.style = /top/.test( a.getAttribute( "style" ) );
	
		// Make sure that URLs aren't manipulated
		// (IE normalizes it by default)
		support.hrefNormalized = a.getAttribute( "href" ) === "/a";
	
		// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
		support.checkOn = !!input.value;
	
		// Make sure that a selected-by-default option has a working selected property.
		// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
		support.optSelected = opt.selected;
	
		// Tests for enctype support on a form (#6743)
		support.enctype = !!document.createElement( "form" ).enctype;
	
		// Make sure that the options inside disabled selects aren't marked as disabled
		// (WebKit marks them as disabled)
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE8 only
		// Check if we can trust getAttribute("value")
		input = document.createElement( "input" );
		input.setAttribute( "value", "" );
		support.input = input.getAttribute( "value" ) === "";
	
		// Check if an input maintains its value after becoming a radio
		input.value = "t";
		input.setAttribute( "type", "radio" );
		support.radioValue = input.value === "t";
	} )();
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if (
						hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
				} else if ( typeof val === "number" ) {
					val += "";
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// oldIE doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled :
									option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1 ) {
	
							// Support: IE6
							// When new option element is added to select box we need to
							// force reflow of newly added node in order to workaround delay
							// of initialization properties
							try {
								option.selected = optionSet = true;
	
							} catch ( _ ) {
	
								// Will be executed only in IE6
								option.scrollHeight;
							}
	
						} else {
							option.selected = false;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
	
					return options;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle,
		ruseDefault = /^(?:checked|selected)$/i,
		getSetAttribute = support.getSetAttribute,
		getSetInput = support.input;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
	
						// Setting the type on a radio button after the value resets the value in IE8-9
						// Reset value to default in case type is set after value during creation
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
							elem[ propName ] = false;
	
						// Support: IE<9
						// Also clear defaultChecked/defaultSelected (if appropriate)
						} else {
							elem[ jQuery.camelCase( "default-" + name ) ] =
								elem[ propName ] = false;
						}
	
					// See #9699 for explanation of this approach (setting first, then removal)
					} else {
						jQuery.attr( elem, name, "" );
					}
	
					elem.removeAttribute( getSetAttribute ? name : propName );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
	
				// IE<8 needs the *property* name
				elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );
	
			} else {
	
				// Support: IE<9
				// Use defaultChecked and defaultSelected for oldIE
				elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
			attrHandle[ name ] = function( elem, name, isXML ) {
				var ret, handle;
				if ( !isXML ) {
	
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[ name ];
					attrHandle[ name ] = ret;
					ret = getter( elem, name, isXML ) != null ?
						name.toLowerCase() :
						null;
					attrHandle[ name ] = handle;
				}
				return ret;
			};
		} else {
			attrHandle[ name ] = function( elem, name, isXML ) {
				if ( !isXML ) {
					return elem[ jQuery.camelCase( "default-" + name ) ] ?
						name.toLowerCase() :
						null;
				}
			};
		}
	} );
	
	// fix oldIE attroperties
	if ( !getSetInput || !getSetAttribute ) {
		jQuery.attrHooks.value = {
			set: function( elem, value, name ) {
				if ( jQuery.nodeName( elem, "input" ) ) {
	
					// Does not return so that setAttribute is also used
					elem.defaultValue = value;
				} else {
	
					// Use nodeHook if defined (#1954); otherwise setAttribute is fine
					return nodeHook && nodeHook.set( elem, value, name );
				}
			}
		};
	}
	
	// IE6/7 do not support getting/setting some attributes with get/setAttribute
	if ( !getSetAttribute ) {
	
		// Use this for any attribute in IE6/7
		// This fixes almost every IE6/7 issue
		nodeHook = {
			set: function( elem, value, name ) {
	
				// Set the existing or create a new attribute node
				var ret = elem.getAttributeNode( name );
				if ( !ret ) {
					elem.setAttributeNode(
						( ret = elem.ownerDocument.createAttribute( name ) )
					);
				}
	
				ret.value = value += "";
	
				// Break association with cloned elements by also using setAttribute (#9646)
				if ( name === "value" || value === elem.getAttribute( name ) ) {
					return value;
				}
			}
		};
	
		// Some attributes are constructed with empty-string values when not defined
		attrHandle.id = attrHandle.name = attrHandle.coords =
			function( elem, name, isXML ) {
				var ret;
				if ( !isXML ) {
					return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
						ret.value :
						null;
				}
			};
	
		// Fixing value retrieval on a button requires this module
		jQuery.valHooks.button = {
			get: function( elem, name ) {
				var ret = elem.getAttributeNode( name );
				if ( ret && ret.specified ) {
					return ret.value;
				}
			},
			set: nodeHook.set
		};
	
		// Set contenteditable to false on removals(#10429)
		// Setting to empty string throws an error as an invalid value
		jQuery.attrHooks.contenteditable = {
			set: function( elem, value, name ) {
				nodeHook.set( elem, value === "" ? false : value, name );
			}
		};
	
		// Set width and height to auto instead of 0 on empty string( Bug #8150 )
		// This is for removals
		jQuery.each( [ "width", "height" ], function( i, name ) {
			jQuery.attrHooks[ name ] = {
				set: function( elem, value ) {
					if ( value === "" ) {
						elem.setAttribute( name, "auto" );
						return value;
					}
				}
			};
		} );
	}
	
	if ( !support.style ) {
		jQuery.attrHooks.style = {
			get: function( elem ) {
	
				// Return undefined in the case of empty string
				// Note: IE uppercases css property names, but if we were to .toLowerCase()
				// .cssText, that would destroy case sensitivity in URL's, like in "background"
				return elem.style.cssText || undefined;
			},
			set: function( elem, value ) {
				return ( elem.style.cssText = value + "" );
			}
		};
	}
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button|object)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			name = jQuery.propFix[ name ] || name;
			return this.each( function() {
	
				// try/catch handles cases where IE balks (such as removing a property on window)
				try {
					this[ name ] = undefined;
					delete this[ name ];
				} catch ( e ) {}
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Some attributes require a special call on IE
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !support.hrefNormalized ) {
	
		// href/src property should get the full normalized URL (#10299/#12915)
		jQuery.each( [ "href", "src" ], function( i, name ) {
			jQuery.propHooks[ name ] = {
				get: function( elem ) {
					return elem.getAttribute( name, 4 );
				}
			};
		} );
	}
	
	// Support: Safari, IE9+
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
	
				if ( parent ) {
					parent.selectedIndex;
	
					// Make sure that it also works with optgroups, see #5701
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	// IE6/7 call enctype encoding
	if ( !support.enctype ) {
		jQuery.propFix.enctype = "encoding";
	}
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return jQuery.attr( elem, "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// store className if set
						jQuery._data( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed "false",
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					jQuery.attr( this, "class",
						className || value === false ?
						"" :
						jQuery._data( this, "__className__" ) || ""
					);
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	
	jQuery.parseJSON = function( data ) {
	
		// Attempt to parse using the native JSON parser first
		if ( window.JSON && window.JSON.parse ) {
	
			// Support: Android 2.3
			// Workaround failure to string-cast null input
			return window.JSON.parse( data + "" );
		}
	
		var requireNonComma,
			depth = null,
			str = jQuery.trim( data + "" );
	
		// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
		// after removing valid tokens
		return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {
	
			// Force termination if we see a misplaced comma
			if ( requireNonComma && comma ) {
				depth = 0;
			}
	
			// Perform no more replacements after returning to outermost depth
			if ( depth === 0 ) {
				return token;
			}
	
			// Commas must not follow "[", "{", or ","
			requireNonComma = open || comma;
	
			// Determine new depth
			// array/object open ("[" or "{"): depth += true - false (increment)
			// array/object close ("]" or "}"): depth += false - true (decrement)
			// other cases ("," or primitive): depth += true - true (numeric cast)
			depth += !close - !open;
	
			// Remove this token
			return "";
		} ) ) ?
			( Function( "return " + str ) )() :
			jQuery.error( "Invalid JSON: " + data );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		try {
			if ( window.DOMParser ) { // Standard
				tmp = new window.DOMParser();
				xml = tmp.parseFromString( data, "text/xml" );
			} else { // IE
				xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
				xml.async = "false";
				xml.loadXML( data );
			}
		} catch ( e ) {
			xml = undefined;
		}
		if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
	
		// IE leaves an \r character at EOL
		rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType.charAt( 0 ) === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var deep, key,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
		var firstDataType, ct, finalDataType, type,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var
	
				// Cross-domain detection vars
				parts,
	
				// Loop variable
				i,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers as string
				responseHeadersString,
	
				// timeout handle
				timeoutTimer,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				transport,
	
				// Response headers
				responseHeaders,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" )
				.replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// We extract error from statusText
					// then normalize statusText and status for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
						elem = elem.firstChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	function getDisplay( elem ) {
		return elem.style && elem.style.display || jQuery.css( elem, "display" );
	}
	
	function filterHidden( elem ) {
	
		// Disconnected elements are considered hidden
		if ( !jQuery.contains( elem.ownerDocument || document, elem ) ) {
			return true;
		}
		while ( elem && elem.nodeType === 1 ) {
			if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
				return true;
			}
			elem = elem.parentNode;
		}
		return false;
	}
	
	jQuery.expr.filters.hidden = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return support.reliableHiddenOffsets() ?
			( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
				!elem.getClientRects().length ) :
				filterHidden( elem );
	};
	
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is(":disabled") so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	// Create the request object
	// (This is still attached to ajaxSettings for backward compatibility)
	jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
	
		// Support: IE6-IE8
		function() {
	
			// XHR cannot access local files, always use ActiveX for that case
			if ( this.isLocal ) {
				return createActiveXHR();
			}
	
			// Support: IE 9-11
			// IE seems to error on cross-domain PATCH requests when ActiveX XHR
			// is used. In IE 9+ always use the native XHR.
			// Note: this condition won't catch Edge as it doesn't define
			// document.documentMode but it also doesn't support ActiveX so it won't
			// reach this code.
			if ( document.documentMode > 8 ) {
				return createStandardXHR();
			}
	
			// Support: IE<9
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
				createStandardXHR() || createActiveXHR();
		} :
	
		// For all other browsers, use the standard XMLHttpRequest object
		createStandardXHR;
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE<10
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]( undefined, true );
			}
		} );
	}
	
	// Determine support properties
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	xhrSupported = support.ajax = !!xhrSupported;
	
	// Create transport if the browser can provide an xhr
	if ( xhrSupported ) {
	
		jQuery.ajaxTransport( function( options ) {
	
			// Cross domain only allowed if supported through XMLHttpRequest
			if ( !options.crossDomain || support.cors ) {
	
				var callback;
	
				return {
					send: function( headers, complete ) {
						var i,
							xhr = options.xhr(),
							id = ++xhrId;
	
						// Open the socket
						xhr.open(
							options.type,
							options.url,
							options.async,
							options.username,
							options.password
						);
	
						// Apply custom fields if provided
						if ( options.xhrFields ) {
							for ( i in options.xhrFields ) {
								xhr[ i ] = options.xhrFields[ i ];
							}
						}
	
						// Override mime type if needed
						if ( options.mimeType && xhr.overrideMimeType ) {
							xhr.overrideMimeType( options.mimeType );
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
							headers[ "X-Requested-With" ] = "XMLHttpRequest";
						}
	
						// Set headers
						for ( i in headers ) {
	
							// Support: IE<9
							// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
							// request header to a null-value.
							//
							// To keep consistent with other XHR implementations, cast the value
							// to string and ignore `undefined`.
							if ( headers[ i ] !== undefined ) {
								xhr.setRequestHeader( i, headers[ i ] + "" );
							}
						}
	
						// Do send the request
						// This may raise an exception which is actually
						// handled in jQuery.ajax (so no try/catch here)
						xhr.send( ( options.hasContent && options.data ) || null );
	
						// Listener
						callback = function( _, isAbort ) {
							var status, statusText, responses;
	
							// Was never called and is aborted or complete
							if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
	
								// Clean up
								delete xhrCallbacks[ id ];
								callback = undefined;
								xhr.onreadystatechange = jQuery.noop;
	
								// Abort manually if needed
								if ( isAbort ) {
									if ( xhr.readyState !== 4 ) {
										xhr.abort();
									}
								} else {
									responses = {};
									status = xhr.status;
	
									// Support: IE<10
									// Accessing binary-data responseText throws an exception
									// (#11426)
									if ( typeof xhr.responseText === "string" ) {
										responses.text = xhr.responseText;
									}
	
									// Firefox throws an exception when accessing
									// statusText for faulty cross-domain requests
									try {
										statusText = xhr.statusText;
									} catch ( e ) {
	
										// We normalize with Webkit giving an empty statusText
										statusText = "";
									}
	
									// Filter status for non standard behaviors
	
									// If the request is local and we have data: assume a success
									// (success with no data won't get notified, that's the best we
									// can do given current implementations)
									if ( !status && options.isLocal && !options.crossDomain ) {
										status = responses.text ? 200 : 404;
	
									// IE - #1450: sometimes returns 1223 when it should be 204
									} else if ( status === 1223 ) {
										status = 204;
									}
								}
							}
	
							// Call complete if needed
							if ( responses ) {
								complete( status, statusText, responses, xhr.getAllResponseHeaders() );
							}
						};
	
						// Do send the request
						// `xhr.send` may raise an exception, but it will be
						// handled in jQuery.ajax (so no try/catch here)
						if ( !options.async ) {
	
							// If we're in sync mode we fire the callback
							callback();
						} else if ( xhr.readyState === 4 ) {
	
							// (IE6 & IE7) if it's in cache and has been
							// retrieved directly we need to fire the callback
							window.setTimeout( callback );
						} else {
	
							// Register the callback, but delay it in case `xhr.send` throws
							// Add to the list of active xhr callbacks
							xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
						}
					},
	
					abort: function() {
						if ( callback ) {
							callback( undefined, true );
						}
					}
				};
			}
		} );
	}
	
	// Functions to create xhrs
	function createStandardXHR() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	}
	
	function createActiveXHR() {
		try {
			return new window.ActiveXObject( "Microsoft.XMLHTTP" );
		} catch ( e ) {}
	}
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and global
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
			s.global = false;
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
	
			var script,
				head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;
	
			return {
	
				send: function( _, callback ) {
	
					script = document.createElement( "script" );
	
					script.async = true;
	
					if ( s.scriptCharset ) {
						script.charset = s.scriptCharset;
					}
	
					script.src = s.url;
	
					// Attach handlers for all browsers
					script.onload = script.onreadystatechange = function( _, isAbort ) {
	
						if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
							// Handle memory leak in IE
							script.onload = script.onreadystatechange = null;
	
							// Remove the script
							if ( script.parentNode ) {
								script.parentNode.removeChild( script );
							}
	
							// Dereference the script
							script = null;
	
							// Callback if not abort
							if ( !isAbort ) {
								callback( 200, "success" );
							}
						}
					};
	
					// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					head.insertBefore( script, head.firstChild );
				},
	
				abort: function() {
					if ( script ) {
						script.onload( undefined, true );
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off, url.length ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ?
			elem :
			elem.nodeType === 9 ?
				elem.defaultView || elem.parentWindow :
				false;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;
	
			// need to be able to calculate position if either top or left
			// is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				box = { top: 0, left: 0 },
				elem = this[ 0 ],
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// If we don't have gBCR, just use 0,0 rather than error
			// BlackBerry 5, iOS 3 (original iPhone)
			if ( typeof elem.getBoundingClientRect !== "undefined" ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
				left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				parentOffset = { top: 0, left: 0 },
				elem = this[ 0 ];
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// we assume that getBoundingClientRect is available when computed position is fixed
				offset = elem.getBoundingClientRect();
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			// note: when an element has margin: auto the offsetLeft and marginLeft
			// are the same in Safari causing offset.left to incorrectly be 0
			return {
				top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = /Y/.test( prop );
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? ( prop in win ) ? win[ prop ] :
						win.document.documentElement[ method ] :
						elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : jQuery( win ).scrollLeft(),
						top ? val : jQuery( win ).scrollTop()
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// getComputedStyle returns percent when specified for top/left/bottom/right
	// rather than make the css module depend on the offset module, we just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// if curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {
	
			// margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						// unfortunately, this causes bug #3838 in IE6/8 only,
						// but there is currently no good, small way to fix it.
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in
	// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9395d9f83f69bff3afc865d0d73f11e8.png";

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f6aa6c4e978d9b617c074b52d88d6290.eot";

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.5.8/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell jshint what variables are being exported */
	/* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  toInt: true,
	  inherit: true,
	  merge: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isBlankObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  equals: true,
	  csp: true,
	  jq: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  convertTimezoneToLocal: true,
	  timezoneToOffset: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	};
	var manualUppercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = "length" in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	           replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) != -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination) {
	  var stackSource = [];
	  var stackDest = [];
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination);
	  }
	
	  return copyElement(source);
	
	  function copyRecurse(source, destination) {
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i]));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key]);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        "Can't copy! Making copies of Window or Scope instances is not supported.");
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        //Support: IE10
	        if (!source.slice) {
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.result;
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 == t2 && t1 == 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) == o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return equals(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() == o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      /* jshint -W031, -W054 */
	      new Function('');
	      /* jshint +W031, +W054 */
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/* jshint -W101 */
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	/* jshint +W101 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) {}
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w\-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || "").split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          "App already bootstrapped with this element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? __webpack_provided_window_dot_jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, "events");
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	             "the module name or forgot to load it. If registering a module ensure that you " +
	             "specify the dependencies as the second argument.", name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method) {
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            invokeQueue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  full: '1.5.8',    // all of these placeholder strings will be replaced by grunt's
	  major: 1,    // package task
	  minor: 5,
	  dot: 8,
	  codeName: 'arbitrary-fallbacks'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            style: styleDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, "", ""]
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteCleanData(nodes) {
	  for (var i = 0, ii = nodes.length; i < ii; i++) {
	    jqLiteRemoveData(nodes[i]);
	  }
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement("div"));
	    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = "";
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = "";
	  fragment.innerHTML = ""; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || function(arg) {
	  // jshint bitwise: false
	  return !!(this.compareDocumentPosition(arg) & 16);
	  // jshint bitwise: true
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) != '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        removeEventListenerFn(element, type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	      indexOf(" " + selector + " ") > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	          .replace(/[\n\t]/g, " ")
	          .replace(" " + trim(cssClass) + " ", " "))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, " ");
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType == NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (window.document.readyState === 'complete') {
	      window.setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // jshint -W064
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	      // jshint +W064
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: jqLiteCleanData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (!!value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          addEventListenerFn(element, type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	    newElement = new JQLite(newElement);
	
	    for (var i = 0, ii = newElement.length; i < ii; i++) {
	      var node = newElement[i];
	      parent.insertBefore(node, index.nextSibling);
	      index = node;
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	
	  // bind legacy bind/unbind to on/off
	  JQLite.prototype.bind = JQLite.prototype.on;
	  JQLite.prototype.unbind = JQLite.prototype.off;
	});
	
	
	// Provider for private $$jqLite service
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType == 'function' || (objType == 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^\(]+?)=>/;
	var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  // Support: Chrome 50-51 only
	  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	  // (See https://github.com/angular/angular.js/issues/14487.)
	  // TODO (gkalpak): Remove workaround when Chrome v52 is released
	  return Function.prototype.toString.call(fn) + ' ';
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	    }
	    return providerCache[name + providerSuffix] = provider_;
	  }
	
	  function enforceReturnValue(name, factory) {
	    return function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          /* jshint -W022 */
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          return cache[serviceName] = factory(serviceName, caller);
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie <= 11) {
	        return false;
	      }
	      // Support: Edge 12-13 only
	      // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	      return typeof func === 'function'
	        && /^(?:class\b|constructor\()/.test(stringifyFn(func));
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      hash = isString(hash) ? hash : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash == 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        domOperation        && domOperation();
	
	        options = options || {};
	        options.from        && element.css(options.from);
	        options.to          && element.css(options.to);
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner(); // jshint ignore:line
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            toAdd    && jqLiteAddClass(elm, toAdd);
	            toRemove && jqLiteRemoveClass(elm, toRemove);
	          });
	          postDigestQueue.remove(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.put(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      afterElement ? afterElement.after(element) : parentElement.prepend(element);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        runner.end && runner.end();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        passed ? callback() : waitForTick(callback);
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        var doc = $document[0];
	
	        // the document may not be ready or attached
	        // to the module for some internal tests
	        if (doc && doc.hidden) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      /* jshint newcap: false */
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,"'");
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    cacheState();
	    fireUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      };
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry != freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd == entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry != prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `true`, an object or a falsy value:
	 *
	 * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created. The new scope rule does not apply for the root of the template
	 * since the root of the template always gets a new scope.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
	 * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
	 * definition: `controller: 'myCtrl as myAlias'`.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default translusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            "Invalid {3} for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition,
	            (isController ? "controller bindings definition" :
	            "isolate scope definition"));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (isObject(bindings.bindToController)) {
	      var controller = directive.controller;
	      var controllerAs = directive.controllerAs;
	      if (!controller) {
	        // There is no controller, there may or may not be a controllerAs property
	        throw $compileMinErr('noctrl',
	              "Cannot bind to controller without directive '{0}'s controller.",
	              directiveName);
	      } else if (!identifierForController(controller, controllerAs)) {
	        // There is a controller, but no identifier or controllerAs property
	        throw $compileMinErr('noident',
	              "Cannot bind to controller without identifier for directive '{0}'.",
	              directiveName);
	      }
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = directive.restrict || 'EA';
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = "";
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (" " + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (" " + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        $$observers && forEach($$observers[observer], function(fn) {
	          try {
	            fn(value);
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = "<span " + attrName + ">";
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol == '{{' && endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	
	      var NOT_EMPTY = /\S+/;
	
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      for (var i = 0, len = $compileNodes.length; i < len; i++) {
	        var domNode = $compileNodes[i];
	
	        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
	          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
	        }
	      }
	
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i+=3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          // use class as directive
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          if (msie === 11) {
	            // Workaround for #11781
	            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	              node.parentNode.removeChild(node.nextSibling);
	            }
	          }
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType == NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        if (directiveValue = directive.scope) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          directiveValue = directive.controller;
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate("'" + directiveName + "' controller",
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        if (directiveValue = directive.transclude) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue == 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	
	            if (isObject(directiveValue)) {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          /* jshint -W021 */
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	          /* jshint +W021 */
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (controller.identifier && bindings) {
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          } else {
	            controller.bindingInfo = {};
	          }
	
	          var controllerResult = controller();
	          if (controllerResult !== controller.instance) {
	            // If the controller constructor has a return value, overwrite the instance
	            // from setupControllers
	            controller.instance = controllerResult;
	            $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	            controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              "Controller '{0}', required by directive '{1}', can't be found!",
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller == '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          try {
	            directive = directives[i];
	            if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	                 directive.restrict.indexOf(location) != -1) {
	              if (startAttrName) {
	                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	              }
	              if (!directive.$$bindings) {
	                var bindings = directive.$$bindings =
	                    parseDirectiveBindings(directive, directive.name);
	                if (isObject(bindings.isolateScope)) {
	                  directive.$$isolateBindings = bindings.isolateScope;
	                }
	              }
	              tDirectives.push(directive);
	              match = directive;
	            }
	          } catch (e) { $exceptionHandler(e); }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr,
	          $element = dst.$$element;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) != '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node == compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName == "srcdoc") {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      if (attrNormalizedName == "xlinkHref" ||
	          (tag == "form" && attrNormalizedName == "action") ||
	          (tag != "img" && (attrNormalizedName == "src" ||
	                            attrNormalizedName == "ngSrc"))) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	      var trustedContext = getTrustedContext(node, name);
	      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	
	      if (name === "multiple" && nodeName_(node) === "select") {
	        throw $compileMinErr("selmulti",
	            "Binding to the 'multiple' attribute is not supported. Element: {0}",
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                          "ng- versions (such as ng-click instead of onclick) instead.");
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] == firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings. This process
	    // only occurs for isolate scopes and new scopes with controllerAs.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = void 0;
	            }
	            attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              return lastValue = parentValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue) return;
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, parentGet.literal);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token == tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT) {
	      splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            "Badly formed controller string '{0}'. " +
	            "Must match `__name__ as __id__` or `__name__`.", expression);
	        }
	        constructor = match[1],
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        var instantiate;
	        return instantiate = extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var $httpMinErr = minErr('$http');
	var $httpMinErrLegacyFn = function(method) {
	  return function() {
	    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	  };
	};
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === void 0) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  var useLegacyPromise = true;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to true. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useLegacyPromiseExtensions = function(value) {
	    if (isDefined(value)) {
	      useLegacyPromise = !!value;
	      return this;
	    }
	    return useLegacyPromise;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString(requestConfig.url)) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	
	      if (useLegacyPromise) {
	        promise.success = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	
	        promise.error = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(null, function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	      } else {
	        promise.success = $httpMinErrLegacyFn('success');
	        promise.error = $httpMinErrLegacyFn('error');
	      }
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.paramSerializer(config.params));
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, "", text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      jsonpDone && jsonpDone();
	      xhr && xhr.abort();
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = "text/javascript";
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, "load", callback);
	      removeEventListenerFn(script, "error", callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = "unknown";
	
	      if (event) {
	        if (event.type === "load" && !callbacks.wasCalled(callbackPath)) {
	          event = { type: "error" };
	        }
	        text = event.type;
	        status = event.type === "error" ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, "load", callback);
	    addEventListenerFn(script, "error", callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	      "interpolations that concatenate multiple expressions when a trusted value is " +
	      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    function stringify(value) {
	      if (value == null) { // null || undefined
	        return '';
	      }
	      switch (typeof value) {
	        case 'string':
	          break;
	        case 'number':
	          value = '' + value;
	          break;
	        default:
	          value = toJson(value);
	      }
	
	      return value;
	    }
	
	    //TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = function() {
	  this.$get = ['$window', function($window) {
	    var callbacks = $window.angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	
	function parseAppUrl(relativeUrl, locationObj) {
	  var prefixed = (relativeUrl.charAt(0) !== '/');
	  if (prefixed) {
	    relativeUrl = '/' + relativeUrl;
	  }
	  var match = urlResolve(relativeUrl);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(haystack, needle) {
	  return haystack.lastIndexOf(needle, 0) === 0;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index == -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile == url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the url starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) == stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase == stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute url is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) == '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          "$location in HTML5 mode requires a <base> tag to be present!");
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() != $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      }())
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) {}
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	var CALL = Function.prototype.call;
	var APPLY = Function.prototype.apply;
	var BIND = Function.prototype.bind;
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	function ensureSafeAssignContext(obj, fullExpression) {
	  if (obj) {
	    if (obj === (0).constructor || obj === (false).constructor || obj === ''.constructor ||
	        obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
	      throw $parseMinErr('isecaf',
	        'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
	    }
	  }
	}
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === "'") {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === "string";
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    /*jshint bitwise: false*/
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	    /*jshint bitwise: true*/
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch == '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch == 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    var token;
	    while ((token = this.expect('|'))) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError("invalid key", this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length != 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      expensiveChecks: expensiveChecks,
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    /* jshint -W054 */
	    var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'getStringValue',
	        'ensureSafeAssignContext',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	          this.$filter,
	          ensureSafeMemberName,
	          ensureSafeObject,
	          ensureSafeFunction,
	          getStringValue,
	          ensureSafeAssignContext,
	          ifDefined,
	          plusFn,
	          expression);
	    /* jshint +W054 */
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      ensureSafeMemberName(ast.name);
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.not(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	        self.addEnsureSafeObject(intoId);
	      }
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (create && create !== 1) {
	            self.addEnsureSafeAssignContext(left);
	          }
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            self.addEnsureSafeMemberName(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.ensureSafeObject(self.computedMember(left, right));
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            ensureSafeMemberName(ast.property.name);
	            if (create && create !== 1) {
	              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	              expression = self.ensureSafeObject(expression);
	            }
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            self.addEnsureSafeFunction(right);
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, self.nextId(), undefined, function(argument) {
	                args.push(self.ensureSafeObject(argument));
	              });
	            });
	            if (left.name) {
	              if (!self.state.expensiveChecks) {
	                self.addEnsureSafeObject(left.context);
	              }
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            expression = self.ensureSafeObject(expression);
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      if (!isAssignable(ast.left)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	          self.addEnsureSafeAssignContext(left.context);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn('s');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn('l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn('v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  addEnsureSafeObject: function(item) {
	    this.current().body.push(this.ensureSafeObject(item), ';');
	  },
	
	  addEnsureSafeMemberName: function(item) {
	    this.current().body.push(this.ensureSafeMemberName(item), ';');
	  },
	
	  addEnsureSafeFunction: function(item) {
	    this.current().body.push(this.ensureSafeFunction(item), ';');
	  },
	
	  addEnsureSafeAssignContext: function(item) {
	    this.current().body.push(this.ensureSafeAssignContext(item), ';');
	  },
	
	  ensureSafeObject: function(item) {
	    return 'ensureSafeObject(' + item + ',text)';
	  },
	
	  ensureSafeMemberName: function(item) {
	    return 'ensureSafeMemberName(' + item + ',text)';
	  },
	
	  ensureSafeFunction: function(item) {
	    return 'ensureSafeFunction(' + item + ',text)';
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  ensureSafeAssignContext: function(item) {
	    return 'ensureSafeAssignContext(' + item + ',text)';
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.expression = expression;
	    this.expensiveChecks = expensiveChecks;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args, expression;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      ensureSafeMemberName(ast.name, self.expression);
	      return self.identifier(ast.name,
	                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	                             context, create, self.expression);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        ensureSafeMemberName(ast.property.name, self.expression);
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create, self.expression) :
	        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            ensureSafeObject(rhs.context, self.expression);
	            ensureSafeFunction(rhs.value, self.expression);
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	            }
	            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        ensureSafeObject(lhs.value, self.expression);
	        ensureSafeAssignContext(lhs.context);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && !(base[name])) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (expensiveChecks) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        ensureSafeMemberName(rhs, expression);
	        if (create && create !== 1) {
	          ensureSafeAssignContext(lhs);
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        ensureSafeAssignContext(lhs);
	        if (lhs && !(lhs[right])) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text, this.options.expensiveChecks);
	  }
	};
	
	function isPossiblyDangerousMemberName(name) {
	  return name == 'constructor';
	}
	
	var objectValueOf = Object.prototype.valueOf;
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensivelly, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    var runningChecksEnabled = false;
	
	    $parse.$$runningExpensiveChecks = function() {
	      return runningChecksEnabled;
	    };
	
	    return $parse;
	
	    function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      expensiveChecks = expensiveChecks || runningChecksEnabled;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            if (expensiveChecks) {
	              parsedExpression = expensiveChecksInterceptor(parsedExpression);
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expensiveChecksInterceptor(fn) {
	      if (!fn) return fn;
	      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
	      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
	      expensiveCheckFn.constant = fn.constant;
	      expensiveCheckFn.literal = fn.literal;
	      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
	        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
	      }
	      expensiveCheckFn.inputs = fn.inputs;
	
	      return expensiveCheckFn;
	
	      function expensiveCheckFn(scope, locals, assign, inputs) {
	        var expensiveCheckOldValue = runningChecksEnabled;
	        runningChecksEnabled = true;
	        try {
	          return fn(scope, locals, assign, inputs);
	        } finally {
	          runningChecksEnabled = expensiveCheckOldValue;
	        }
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  var defer = function() {
	    var d = new Deferred();
	    //Necessary to support unbound execution :/
	    d.resolve = simpleBind(d, d.resolve);
	    d.reject = simpleBind(d, d.reject);
	    d.notify = simpleBind(d, d.notify);
	    return d;
	  };
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    "catch": function(callback) {
	      return this.then(null, callback);
	    },
	
	    "finally": function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, true, callback);
	      }, function(error) {
	        return handleCallback(error, false, callback);
	      }, progressBack);
	    }
	  });
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, deferred, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      deferred = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          deferred.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          deferred.resolve(state.value);
	        } else {
	          deferred.reject(state.value);
	        }
	      } catch (e) {
	        deferred.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	  }
	
	  extend(Deferred.prototype, {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          "Expected promise to be resolved with value other than itself '{0}'",
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then;
	      var that = this;
	      var done = false;
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        rejectPromise(e);
	        exceptionHandler(e);
	      }
	
	      function resolvePromise(val) {
	        if (done) return;
	        done = true;
	        that.$$resolve(val);
	      }
	      function rejectPromise(val) {
	        if (done) return;
	        done = true;
	        that.$$reject(val);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  var reject = function(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  };
	
	  var makePromise = function makePromise(value, resolved) {
	    var result = new Deferred();
	    if (resolved) {
	      result.resolve(value);
	    } else {
	      result.reject(value);
	    }
	    return result.promise;
	  };
	
	  var handleCallback = function handleCallback(value, isResolved, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return makePromise(e, false);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return makePromise(value, isResolved);
	      }, function(error) {
	        return makePromise(error, false);
	      });
	    } else {
	      return makePromise(value, isResolved);
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  var when = function(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        if (results.hasOwnProperty(key)) return;
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        if (results.hasOwnProperty(key)) return;
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  var $Q = function Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  };
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        $scope.$$childHead && cleanUpScope($scope.$$childHead);
	        $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          if (arrayRemove(array, watcher) >= 0) {
	            incrementWatchersCount(scope, -1);
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            length,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              length = watchers.length;
	              while (length--) {
	                try {
	                  watch = watchers[length];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (typeof value === 'number' && typeof last === 'number'
	                               && isNaN(value) && isNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        expr && applyAsyncQueue.push($applyAsyncExpression);
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace('\\*\\*', '.*').
	                  replace('\\*', '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/* jshint maxlen: false*/
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	/* jshint maxlen: 100 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase("parse_as_" + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase("get_trusted_" + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase("trust_as_" + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
	        // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
	        isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if (match = vendorRegex.exec(prop)) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(bodyStyle.webkitTransition);
	        animations = isString(bodyStyle.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      // jshint -W018
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      // jshint +W018
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      return $http.get(tpl, extend({
	          cache: $templateCache,
	          transformResponse: transformResponse
	        }, httpOptions))
	        ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          $templateCache.put(tpl, response.data);
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	            tpl, resp.status, resp.statusText);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) != -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        }
	        finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement("a");
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute("href", href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = rawDocument.cookie || '';
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 *     Primitive values are converted to strings. Objects are not compared against primitives,
	 *     unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 * @param {string=} anyPropertyKey The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        //jshint -W086
	      case 'object':
	        //jshint +W086
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	      break;
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}
	
	  if (i == (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset == -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? "+" : "";
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if (match = string.match(R_ISO8601_STR)) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceeding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	          descending = predicate.charAt(0) == '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example>
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName == "multiple") return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set("ngPattern", new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	  form.$$parentForm = nullFormCtrl;
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	
	    control.$$parentForm = form;
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	    control.$$parentForm = nullFormCtrl;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    form.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    form.$$parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	/* jshint maxlen:220 */
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	/* jshint maxlen:200 */
	var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputing intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal;
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val);
	      }
	      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal;
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val);
	      }
	      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            // jshint bitwise: false
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(scope.$eval(attr[name]));
	              mod === selector ?
	                addClasses(classes) :
	                removeClasses(classes);
	            }
	          });
	        }
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          var classCounts = element.data('$classCounts') || createMap();
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          // jshint bitwise: false
	          if (selector === true || (scope.$index & 1) === selector) {
	          // jshint bitwise: true
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          if (isArray(newVal)) {
	            oldVal = newVal.map(function(v) { return shallowCopy(v); });
	          } else {
	            oldVal = shallowCopy(newVal);
	          }
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      var classes = [];
	      if (isArray(classVal)) {
	        forEach(classVal, function(v) {
	          classes = classes.concat(arrayClasses(v));
	        });
	        return classes;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 *
	 * Angular has some features that can break certain
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement these rules then you must tell Angular not to use these features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following rules affect Angular:
	 *
	 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	 * increase in the speed of evaluating Angular expressions.
	 *
	 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	 * `angular-csp.css` in your HTML manually.
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	 * however, triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).then(function() {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function() {
	            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	              $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).then(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  this.$$updateEmptyClasses = function(value) {
	    if (ctrl.$isEmpty(value)) {
	      $animate.removeClass($element, NOT_EMPTY_CLASS);
	      $animate.addClass($element, EMPTY_CLASS);
	    } else {
	      $animate.removeClass($element, EMPTY_CLASS);
	      $animate.addClass($element, NOT_EMPTY_CLASS);
	    }
	  };
	
	
	  var currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    ctrl.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as blur, you can have a situation where there is a period when
	   * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode == 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *        empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *        <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                ng-keydown="setEmpty($event, 'value1')">
	   *         value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *        <p id="inputDescription2">With $rollbackViewValue():</p>
	   *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                ng-keydown="setEmpty($event, 'value2', true)">
	   *         value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (isUndefined(parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$updateEmptyClasses(viewValue);
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        ctrl.$$runValidators(modelValue, viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	        <pre>user.data = <span ng-bind="user.data"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function($scope, $attrs) {
	      var that = this;
	      this.$options = copy($scope.$eval($attrs.ngModelOptions));
	      // Allow adding/overriding bound events
	      if (isDefined(this.$options.updateOn)) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	// jshint maxlen: 100
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        "Expected expression in form of " +
	        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	        " but got '{0}'. Element: {1}",
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        emptyOption.prop('selected', true); // needed for IE
	        emptyOption.attr('selected', true);
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        }
	      };
	
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var option = options.getOptionFromViewValue(value);
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        // remove the class, which is added automatically because we recompile the element and it
	        // becomes the compilation root
	        emptyOption.removeClass('ng-scope');
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        if (option.value !== element.value) element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, ngRepeat will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have an identifier property, you should track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *     {{model.name}}
	 * </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // jshint bitwise: false
	    scope.$odd = !(scope.$even = (index&1) === 0);
	    // jshint bitwise: true
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) != nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function ngSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	          $animate.cancel(previousLeaveAnimations[i]);
	        }
	        previousLeaveAnimations.length = 0;
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	          promise.then(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
	 * that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}">{{text}}</pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function(){
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = "https://google.com";
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type == 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function chromeHack(optionElement) {
	  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	  // Adding an <option selected="selected"> element to a <select required="required"> should
	  // automatically select the new element
	  if (optionElement[0].hasAttribute('selected')) {
	    optionElement[0].selected = true;
	  }
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', function($element, $scope) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	  self.renderUnknownOption = function(val) {
	    var unknownVal = '? ' + hashKey(val) + ' ?';
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    self.removeUnknownOption();
	    return $element.val();
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	      $element.val(value);
	      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        $element.val('');
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	    self.ngModelCtrl.$render();
	    chromeHack(element);
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (interpolateValueFn) {
	      // The value attribute is interpolated
	      var oldVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	    optionElement.on('$destroy', function() {
	      self.removeOption(optionAttrs.value);
	      self.ngModelCtrl.$render();
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explicitly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        var interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        var interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	var styleDirective = valueFn({
	  restrict: 'E',
	  terminal: false
	});
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  //AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(window.document).ready(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	module.exports = angular;


/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	var app = angular.module('app', []);
	
	app.controller('main', function ($scope) {
	  console.log('main controller...');
	});

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	/*! device.js 0.1.57 */
	(function () {
	  var a, b, c, d, e, f, g, h, i;window.device = {}, b = window.document.documentElement, i = window.navigator.userAgent.toLowerCase(), device.ios = function () {
	    return device.iphone() || device.ipod() || device.ipad();
	  }, device.iphone = function () {
	    return c("iphone");
	  }, device.ipod = function () {
	    return c("ipod");
	  }, device.ipad = function () {
	    return c("ipad");
	  }, device.android = function () {
	    return c("android");
	  }, device.androidPhone = function () {
	    return device.android() && c("mobile");
	  }, device.androidTablet = function () {
	    return device.android() && !c("mobile");
	  }, device.blackberry = function () {
	    return c("blackberry") || c("bb10") || c("rim");
	  }, device.blackberryPhone = function () {
	    return device.blackberry() && !c("tablet");
	  }, device.blackberryTablet = function () {
	    return device.blackberry() && c("tablet");
	  }, device.windows = function () {
	    return c("windows");
	  }, device.windowsPhone = function () {
	    return device.windows() && c("phone");
	  }, device.windowsTablet = function () {
	    return device.windows() && c("touch");
	  }, device.fxos = function () {
	    return c("(mobile; rv:") || c("(tablet; rv:");
	  }, device.fxosPhone = function () {
	    return device.fxos() && c("mobile");
	  }, device.fxosTablet = function () {
	    return device.fxos() && c("tablet");
	  }, device.mobile = function () {
	    return device.androidPhone() || device.iphone() || device.ipod() || device.windowsPhone() || device.blackberryPhone() || device.fxosPhone();
	  }, device.tablet = function () {
	    return device.ipad() || device.androidTablet() || device.blackberryTablet() || device.windowsTablet() || device.fxosTablet();
	  }, device.portrait = function () {
	    return 90 !== Math.abs(window.orientation);
	  }, device.landscape = function () {
	    return 90 === Math.abs(window.orientation);
	  }, c = function c(a) {
	    return -1 !== i.indexOf(a);
	  }, e = function e(a) {
	    var c;return c = new RegExp(a, "i"), b.className.match(c);
	  }, a = function a(_a) {
	    return e(_a) ? void 0 : b.className += " " + _a;
	  }, g = function g(a) {
	    return e(a) ? b.className = b.className.replace(a, "") : void 0;
	  }, device.ios() ? device.ipad() ? a("ios ipad tablet") : device.iphone() ? a("ios iphone mobile") : device.ipod() && a("ios ipod mobile") : device.android() ? device.androidTablet() ? a("android tablet") : a("android mobile") : device.blackberry() ? device.blackberryTablet() ? a("blackberry tablet") : a("blackberry mobile") : device.windows() ? device.windowsTablet() ? a("windows tablet") : device.windowsPhone() ? a("windows mobile") : a("desktop") : device.fxos() ? device.fxosTablet() ? a("fxos tablet") : a("fxos mobile") : a("desktop"), d = function d() {
	    return device.landscape() ? (g("portrait"), a("landscape")) : (g("landscape"), a("portrait"));
	  }, h = "onorientationchange" in window, f = h ? "orientationchange" : "resize", window.addEventListener ? window.addEventListener(f, d, !1) : window.attachEvent ? window.attachEvent(f, d) : window[f] = d, d();
	}).call(undefined);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {"use strict";
	
	/*! Magnific Popup - v0.9.9 - 2013-12-27
	* http://dimsemenov.com/plugins/magnific-popup/
	* Copyright (c) 2013 Dmitry Semenov; */
	(function (e) {
	  var t,
	      n,
	      i,
	      o,
	      r,
	      a,
	      s,
	      l = "Close",
	      c = "BeforeClose",
	      d = "AfterClose",
	      u = "BeforeAppend",
	      p = "MarkupParse",
	      f = "Open",
	      m = "Change",
	      g = "mfp",
	      h = "." + g,
	      v = "mfp-ready",
	      C = "mfp-removing",
	      y = "mfp-prevent-close",
	      w = function w() {},
	      b = !!__webpack_provided_window_dot_jQuery,
	      I = e(window),
	      x = function x(e, n) {
	    t.ev.on(g + e + h, n);
	  },
	      k = function k(t, n, i, o) {
	    var r = document.createElement("div");return r.className = "mfp-" + t, i && (r.innerHTML = i), o ? n && n.appendChild(r) : (r = e(r), n && r.appendTo(n)), r;
	  },
	      T = function T(n, i) {
	    t.ev.triggerHandler(g + n, i), t.st.callbacks && (n = n.charAt(0).toLowerCase() + n.slice(1), t.st.callbacks[n] && t.st.callbacks[n].apply(t, e.isArray(i) ? i : [i]));
	  },
	      E = function E(n) {
	    return n === s && t.currTemplate.closeBtn || (t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose)), s = n), t.currTemplate.closeBtn;
	  },
	      _ = function _() {
	    e.magnificPopup.instance || (t = new w(), t.init(), e.magnificPopup.instance = t);
	  },
	      S = function S() {
	    var e = document.createElement("p").style,
	        t = ["ms", "O", "Moz", "Webkit"];if (void 0 !== e.transition) return !0;for (; t.length;) {
	      if (t.pop() + "Transition" in e) return !0;
	    }return !1;
	  };w.prototype = { constructor: w, init: function init() {
	      var n = navigator.appVersion;t.isIE7 = -1 !== n.indexOf("MSIE 7."), t.isIE8 = -1 !== n.indexOf("MSIE 8."), t.isLowIE = t.isIE7 || t.isIE8, t.isAndroid = /android/gi.test(n), t.isIOS = /iphone|ipad|ipod/gi.test(n), t.supportsTransition = S(), t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), o = e(document), t.popupsCache = {};
	    }, open: function open(n) {
	      i || (i = e(document.body));var r;if (n.isObj === !1) {
	        t.items = n.items.toArray(), t.index = 0;var s,
	            l = n.items;for (r = 0; l.length > r; r++) {
	          if (s = l[r], s.parsed && (s = s.el[0]), s === n.el[0]) {
	            t.index = r;break;
	          }
	        }
	      } else t.items = e.isArray(n.items) ? n.items : [n.items], t.index = n.index || 0;if (t.isOpen) return t.updateItemHTML(), void 0;t.types = [], a = "", t.ev = n.mainEl && n.mainEl.length ? n.mainEl.eq(0) : o, n.key ? (t.popupsCache[n.key] || (t.popupsCache[n.key] = {}), t.currTemplate = t.popupsCache[n.key]) : t.currTemplate = {}, t.st = e.extend(!0, {}, e.magnificPopup.defaults, n), t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos, t.st.modal && (t.st.closeOnContentClick = !1, t.st.closeOnBgClick = !1, t.st.showCloseBtn = !1, t.st.enableEscapeKey = !1), t.bgOverlay || (t.bgOverlay = k("bg").on("click" + h, function () {
	        t.close();
	      }), t.wrap = k("wrap").attr("tabindex", -1).on("click" + h, function (e) {
	        t._checkIfClose(e.target) && t.close();
	      }), t.container = k("container", t.wrap)), t.contentContainer = k("content"), t.st.preloader && (t.preloader = k("preloader", t.container, t.st.tLoading));var c = e.magnificPopup.modules;for (r = 0; c.length > r; r++) {
	        var d = c[r];d = d.charAt(0).toUpperCase() + d.slice(1), t["init" + d].call(t);
	      }T("BeforeOpen"), t.st.showCloseBtn && (t.st.closeBtnInside ? (x(p, function (e, t, n, i) {
	        n.close_replaceWith = E(i.type);
	      }), a += " mfp-close-btn-in") : t.wrap.append(E())), t.st.alignTop && (a += " mfp-align-top"), t.fixedContentPos ? t.wrap.css({ overflow: t.st.overflowY, overflowX: "hidden", overflowY: t.st.overflowY }) : t.wrap.css({ top: I.scrollTop(), position: "absolute" }), (t.st.fixedBgPos === !1 || "auto" === t.st.fixedBgPos && !t.fixedContentPos) && t.bgOverlay.css({ height: o.height(), position: "absolute" }), t.st.enableEscapeKey && o.on("keyup" + h, function (e) {
	        27 === e.keyCode && t.close();
	      }), I.on("resize" + h, function () {
	        t.updateSize();
	      }), t.st.closeOnContentClick || (a += " mfp-auto-cursor"), a && t.wrap.addClass(a);var u = t.wH = I.height(),
	          m = {};if (t.fixedContentPos && t._hasScrollBar(u)) {
	        var g = t._getScrollbarSize();g && (m.marginRight = g);
	      }t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : m.overflow = "hidden");var C = t.st.mainClass;return t.isIE7 && (C += " mfp-ie7"), C && t._addClassToMFP(C), t.updateItemHTML(), T("BuildControls"), e("html").css(m), t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || i), t._lastFocusedEl = document.activeElement, setTimeout(function () {
	        t.content ? (t._addClassToMFP(v), t._setFocus()) : t.bgOverlay.addClass(v), o.on("focusin" + h, t._onFocusIn);
	      }, 16), t.isOpen = !0, t.updateSize(u), T(f), n;
	    }, close: function close() {
	      t.isOpen && (T(c), t.isOpen = !1, t.st.removalDelay && !t.isLowIE && t.supportsTransition ? (t._addClassToMFP(C), setTimeout(function () {
	        t._close();
	      }, t.st.removalDelay)) : t._close());
	    }, _close: function _close() {
	      T(l);var n = C + " " + v + " ";if (t.bgOverlay.detach(), t.wrap.detach(), t.container.empty(), t.st.mainClass && (n += t.st.mainClass + " "), t._removeClassFromMFP(n), t.fixedContentPos) {
	        var i = { marginRight: "" };t.isIE7 ? e("body, html").css("overflow", "") : i.overflow = "", e("html").css(i);
	      }o.off("keyup" + h + " focusin" + h), t.ev.off(h), t.wrap.attr("class", "mfp-wrap").removeAttr("style"), t.bgOverlay.attr("class", "mfp-bg"), t.container.attr("class", "mfp-container"), !t.st.showCloseBtn || t.st.closeBtnInside && t.currTemplate[t.currItem.type] !== !0 || t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach(), t._lastFocusedEl && e(t._lastFocusedEl).focus(), t.currItem = null, t.content = null, t.currTemplate = null, t.prevHeight = 0, T(d);
	    }, updateSize: function updateSize(e) {
	      if (t.isIOS) {
	        var n = document.documentElement.clientWidth / window.innerWidth,
	            i = window.innerHeight * n;t.wrap.css("height", i), t.wH = i;
	      } else t.wH = e || I.height();t.fixedContentPos || t.wrap.css("height", t.wH), T("Resize");
	    }, updateItemHTML: function updateItemHTML() {
	      var n = t.items[t.index];t.contentContainer.detach(), t.content && t.content.detach(), n.parsed || (n = t.parseEl(t.index));var i = n.type;if (T("BeforeChange", [t.currItem ? t.currItem.type : "", i]), t.currItem = n, !t.currTemplate[i]) {
	        var o = t.st[i] ? t.st[i].markup : !1;T("FirstMarkupParse", o), t.currTemplate[i] = o ? e(o) : !0;
	      }r && r !== n.type && t.container.removeClass("mfp-" + r + "-holder");var a = t["get" + i.charAt(0).toUpperCase() + i.slice(1)](n, t.currTemplate[i]);t.appendContent(a, i), n.preloaded = !0, T(m, n), r = n.type, t.container.prepend(t.contentContainer), T("AfterChange");
	    }, appendContent: function appendContent(e, n) {
	      t.content = e, e ? t.st.showCloseBtn && t.st.closeBtnInside && t.currTemplate[n] === !0 ? t.content.find(".mfp-close").length || t.content.append(E()) : t.content = e : t.content = "", T(u), t.container.addClass("mfp-" + n + "-holder"), t.contentContainer.append(t.content);
	    }, parseEl: function parseEl(n) {
	      var i,
	          o = t.items[n];if (o.tagName ? o = { el: e(o) } : (i = o.type, o = { data: o, src: o.src }), o.el) {
	        for (var r = t.types, a = 0; r.length > a; a++) {
	          if (o.el.hasClass("mfp-" + r[a])) {
	            i = r[a];break;
	          }
	        }o.src = o.el.attr("data-mfp-src"), o.src || (o.src = o.el.attr("href"));
	      }return o.type = i || t.st.type || "inline", o.index = n, o.parsed = !0, t.items[n] = o, T("ElementParse", o), t.items[n];
	    }, addGroup: function addGroup(e, n) {
	      var i = function i(_i) {
	        _i.mfpEl = this, t._openClick(_i, e, n);
	      };n || (n = {});var o = "click.magnificPopup";n.mainEl = e, n.items ? (n.isObj = !0, e.off(o).on(o, i)) : (n.isObj = !1, n.delegate ? e.off(o).on(o, n.delegate, i) : (n.items = e, e.off(o).on(o, i)));
	    }, _openClick: function _openClick(n, i, o) {
	      var r = void 0 !== o.midClick ? o.midClick : e.magnificPopup.defaults.midClick;if (r || 2 !== n.which && !n.ctrlKey && !n.metaKey) {
	        var a = void 0 !== o.disableOn ? o.disableOn : e.magnificPopup.defaults.disableOn;if (a) if (e.isFunction(a)) {
	          if (!a.call(t)) return !0;
	        } else if (a > I.width()) return !0;n.type && (n.preventDefault(), t.isOpen && n.stopPropagation()), o.el = e(n.mfpEl), o.delegate && (o.items = i.find(o.delegate)), t.open(o);
	      }
	    }, updateStatus: function updateStatus(e, i) {
	      if (t.preloader) {
	        n !== e && t.container.removeClass("mfp-s-" + n), i || "loading" !== e || (i = t.st.tLoading);var o = { status: e, text: i };T("UpdateStatus", o), e = o.status, i = o.text, t.preloader.html(i), t.preloader.find("a").on("click", function (e) {
	          e.stopImmediatePropagation();
	        }), t.container.addClass("mfp-s-" + e), n = e;
	      }
	    }, _checkIfClose: function _checkIfClose(n) {
	      if (!e(n).hasClass(y)) {
	        var i = t.st.closeOnContentClick,
	            o = t.st.closeOnBgClick;if (i && o) return !0;if (!t.content || e(n).hasClass("mfp-close") || t.preloader && n === t.preloader[0]) return !0;if (n === t.content[0] || e.contains(t.content[0], n)) {
	          if (i) return !0;
	        } else if (o && e.contains(document, n)) return !0;return !1;
	      }
	    }, _addClassToMFP: function _addClassToMFP(e) {
	      t.bgOverlay.addClass(e), t.wrap.addClass(e);
	    }, _removeClassFromMFP: function _removeClassFromMFP(e) {
	      this.bgOverlay.removeClass(e), t.wrap.removeClass(e);
	    }, _hasScrollBar: function _hasScrollBar(e) {
	      return (t.isIE7 ? o.height() : document.body.scrollHeight) > (e || I.height());
	    }, _setFocus: function _setFocus() {
	      (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus();
	    }, _onFocusIn: function _onFocusIn(n) {
	      return n.target === t.wrap[0] || e.contains(t.wrap[0], n.target) ? void 0 : (t._setFocus(), !1);
	    }, _parseMarkup: function _parseMarkup(t, n, i) {
	      var o;i.data && (n = e.extend(i.data, n)), T(p, [t, n, i]), e.each(n, function (e, n) {
	        if (void 0 === n || n === !1) return !0;if (o = e.split("_"), o.length > 1) {
	          var i = t.find(h + "-" + o[0]);if (i.length > 0) {
	            var r = o[1];"replaceWith" === r ? i[0] !== n[0] && i.replaceWith(n) : "img" === r ? i.is("img") ? i.attr("src", n) : i.replaceWith('<img src="' + n + '" class="' + i.attr("class") + '" />') : i.attr(o[1], n);
	          }
	        } else t.find(h + "-" + e).html(n);
	      });
	    }, _getScrollbarSize: function _getScrollbarSize() {
	      if (void 0 === t.scrollbarSize) {
	        var e = document.createElement("div");e.id = "mfp-sbm", e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(e), t.scrollbarSize = e.offsetWidth - e.clientWidth, document.body.removeChild(e);
	      }return t.scrollbarSize;
	    } }, e.magnificPopup = { instance: null, proto: w.prototype, modules: [], open: function open(t, n) {
	      return _(), t = t ? e.extend(!0, {}, t) : {}, t.isObj = !0, t.index = n || 0, this.instance.open(t);
	    }, close: function close() {
	      return e.magnificPopup.instance && e.magnificPopup.instance.close();
	    }, registerModule: function registerModule(t, n) {
	      n.options && (e.magnificPopup.defaults[t] = n.options), e.extend(this.proto, n.proto), this.modules.push(t);
	    }, defaults: { disableOn: 0, key: null, midClick: !1, mainClass: "", preloader: !0, focus: "", closeOnContentClick: !1, closeOnBgClick: !0, closeBtnInside: !0, showCloseBtn: !0, enableEscapeKey: !0, modal: !1, alignTop: !1, removalDelay: 0, prependTo: null, fixedContentPos: "auto", fixedBgPos: "auto", overflowY: "auto", closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>', tClose: "Close (Esc)", tLoading: "Loading..." } }, e.fn.magnificPopup = function (n) {
	    _();var i = e(this);if ("string" == typeof n) {
	      if ("open" === n) {
	        var o,
	            r = b ? i.data("magnificPopup") : i[0].magnificPopup,
	            a = parseInt(arguments[1], 10) || 0;r.items ? o = r.items[a] : (o = i, r.delegate && (o = o.find(r.delegate)), o = o.eq(a)), t._openClick({ mfpEl: o }, i, r);
	      } else t.isOpen && t[n].apply(t, Array.prototype.slice.call(arguments, 1));
	    } else n = e.extend(!0, {}, n), b ? i.data("magnificPopup", n) : i[0].magnificPopup = n, t.addGroup(i, n);return i;
	  };var P,
	      O,
	      z,
	      M = "inline",
	      B = function B() {
	    z && (O.after(z.addClass(P)).detach(), z = null);
	  };e.magnificPopup.registerModule(M, { options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" }, proto: { initInline: function initInline() {
	        t.types.push(M), x(l + "." + M, function () {
	          B();
	        });
	      }, getInline: function getInline(n, i) {
	        if (B(), n.src) {
	          var o = t.st.inline,
	              r = e(n.src);if (r.length) {
	            var a = r[0].parentNode;a && a.tagName && (O || (P = o.hiddenClass, O = k(P), P = "mfp-" + P), z = r.after(O).detach().removeClass(P)), t.updateStatus("ready");
	          } else t.updateStatus("error", o.tNotFound), r = e("<div>");return n.inlineElement = r, r;
	        }return t.updateStatus("ready"), t._parseMarkup(i, {}, n), i;
	      } } });var F,
	      H = "ajax",
	      L = function L() {
	    F && i.removeClass(F);
	  },
	      A = function A() {
	    L(), t.req && t.req.abort();
	  };e.magnificPopup.registerModule(H, { options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' }, proto: { initAjax: function initAjax() {
	        t.types.push(H), F = t.st.ajax.cursor, x(l + "." + H, A), x("BeforeChange." + H, A);
	      }, getAjax: function getAjax(n) {
	        F && i.addClass(F), t.updateStatus("loading");var o = e.extend({ url: n.src, success: function success(i, o, r) {
	            var a = { data: i, xhr: r };T("ParseAjax", a), t.appendContent(e(a.data), H), n.finished = !0, L(), t._setFocus(), setTimeout(function () {
	              t.wrap.addClass(v);
	            }, 16), t.updateStatus("ready"), T("AjaxContentAdded");
	          }, error: function error() {
	            L(), n.finished = n.loadError = !0, t.updateStatus("error", t.st.ajax.tError.replace("%url%", n.src));
	          } }, t.st.ajax.settings);return t.req = e.ajax(o), "";
	      } } });var j,
	      N = function N(n) {
	    if (n.data && void 0 !== n.data.title) return n.data.title;var i = t.st.image.titleSrc;if (i) {
	      if (e.isFunction(i)) return i.call(t, n);if (n.el) return n.el.attr(i) || "";
	    }return "";
	  };e.magnificPopup.registerModule("image", { options: { markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>', cursor: "mfp-zoom-out-cur", titleSrc: "title", verticalFit: !0, tError: '<a href="%url%">The image</a> could not be loaded.' }, proto: { initImage: function initImage() {
	        var e = t.st.image,
	            n = ".image";t.types.push("image"), x(f + n, function () {
	          "image" === t.currItem.type && e.cursor && i.addClass(e.cursor);
	        }), x(l + n, function () {
	          e.cursor && i.removeClass(e.cursor), I.off("resize" + h);
	        }), x("Resize" + n, t.resizeImage), t.isLowIE && x("AfterChange", t.resizeImage);
	      }, resizeImage: function resizeImage() {
	        var e = t.currItem;if (e && e.img && t.st.image.verticalFit) {
	          var n = 0;t.isLowIE && (n = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)), e.img.css("max-height", t.wH - n);
	        }
	      }, _onImageHasSize: function _onImageHasSize(e) {
	        e.img && (e.hasSize = !0, j && clearInterval(j), e.isCheckingImgSize = !1, T("ImageHasSize", e), e.imgHidden && (t.content && t.content.removeClass("mfp-loading"), e.imgHidden = !1));
	      }, findImageSize: function findImageSize(e) {
	        var n = 0,
	            i = e.img[0],
	            o = function o(r) {
	          j && clearInterval(j), j = setInterval(function () {
	            return i.naturalWidth > 0 ? (t._onImageHasSize(e), void 0) : (n > 200 && clearInterval(j), n++, 3 === n ? o(10) : 40 === n ? o(50) : 100 === n && o(500), void 0);
	          }, r);
	        };o(1);
	      }, getImage: function getImage(n, i) {
	        var o = 0,
	            r = function r() {
	          n && (n.img[0].complete ? (n.img.off(".mfploader"), n === t.currItem && (t._onImageHasSize(n), t.updateStatus("ready")), n.hasSize = !0, n.loaded = !0, T("ImageLoadComplete")) : (o++, 200 > o ? setTimeout(r, 100) : a()));
	        },
	            a = function a() {
	          n && (n.img.off(".mfploader"), n === t.currItem && (t._onImageHasSize(n), t.updateStatus("error", s.tError.replace("%url%", n.src))), n.hasSize = !0, n.loaded = !0, n.loadError = !0);
	        },
	            s = t.st.image,
	            l = i.find(".mfp-img");if (l.length) {
	          var c = document.createElement("img");c.className = "mfp-img", n.img = e(c).on("load.mfploader", r).on("error.mfploader", a), c.src = n.src, l.is("img") && (n.img = n.img.clone()), c = n.img[0], c.naturalWidth > 0 ? n.hasSize = !0 : c.width || (n.hasSize = !1);
	        }return t._parseMarkup(i, { title: N(n), img_replaceWith: n.img }, n), t.resizeImage(), n.hasSize ? (j && clearInterval(j), n.loadError ? (i.addClass("mfp-loading"), t.updateStatus("error", s.tError.replace("%url%", n.src))) : (i.removeClass("mfp-loading"), t.updateStatus("ready")), i) : (t.updateStatus("loading"), n.loading = !0, n.hasSize || (n.imgHidden = !0, i.addClass("mfp-loading"), t.findImageSize(n)), i);
	      } } });var W,
	      R = function R() {
	    return void 0 === W && (W = void 0 !== document.createElement("p").style.MozTransform), W;
	  };e.magnificPopup.registerModule("zoom", { options: { enabled: !1, easing: "ease-in-out", duration: 300, opener: function opener(e) {
	        return e.is("img") ? e : e.find("img");
	      } }, proto: { initZoom: function initZoom() {
	        var e,
	            n = t.st.zoom,
	            i = ".zoom";if (n.enabled && t.supportsTransition) {
	          var o,
	              r,
	              a = n.duration,
	              s = function s(e) {
	            var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
	                i = "all " + n.duration / 1e3 + "s " + n.easing,
	                o = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" },
	                r = "transition";return o["-webkit-" + r] = o["-moz-" + r] = o["-o-" + r] = o[r] = i, t.css(o), t;
	          },
	              d = function d() {
	            t.content.css("visibility", "visible");
	          };x("BuildControls" + i, function () {
	            if (t._allowZoom()) {
	              if (clearTimeout(o), t.content.css("visibility", "hidden"), e = t._getItemToZoom(), !e) return d(), void 0;r = s(e), r.css(t._getOffset()), t.wrap.append(r), o = setTimeout(function () {
	                r.css(t._getOffset(!0)), o = setTimeout(function () {
	                  d(), setTimeout(function () {
	                    r.remove(), e = r = null, T("ZoomAnimationEnded");
	                  }, 16);
	                }, a);
	              }, 16);
	            }
	          }), x(c + i, function () {
	            if (t._allowZoom()) {
	              if (clearTimeout(o), t.st.removalDelay = a, !e) {
	                if (e = t._getItemToZoom(), !e) return;r = s(e);
	              }r.css(t._getOffset(!0)), t.wrap.append(r), t.content.css("visibility", "hidden"), setTimeout(function () {
	                r.css(t._getOffset());
	              }, 16);
	            }
	          }), x(l + i, function () {
	            t._allowZoom() && (d(), r && r.remove(), e = null);
	          });
	        }
	      }, _allowZoom: function _allowZoom() {
	        return "image" === t.currItem.type;
	      }, _getItemToZoom: function _getItemToZoom() {
	        return t.currItem.hasSize ? t.currItem.img : !1;
	      }, _getOffset: function _getOffset(n) {
	        var i;i = n ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem);var o = i.offset(),
	            r = parseInt(i.css("padding-top"), 10),
	            a = parseInt(i.css("padding-bottom"), 10);o.top -= e(window).scrollTop() - r;var s = { width: i.width(), height: (b ? i.innerHeight() : i[0].offsetHeight) - a - r };return R() ? s["-moz-transform"] = s.transform = "translate(" + o.left + "px," + o.top + "px)" : (s.left = o.left, s.top = o.top), s;
	      } } });var Z = "iframe",
	      q = "//about:blank",
	      D = function D(e) {
	    if (t.currTemplate[Z]) {
	      var n = t.currTemplate[Z].find("iframe");n.length && (e || (n[0].src = q), t.isIE8 && n.css("display", e ? "block" : "none"));
	    }
	  };e.magnificPopup.registerModule(Z, { options: { markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>', srcAction: "iframe_src", patterns: { youtube: { index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" }, vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" }, gmaps: { index: "//maps.google.", src: "%id%&output=embed" } } }, proto: { initIframe: function initIframe() {
	        t.types.push(Z), x("BeforeChange", function (e, t, n) {
	          t !== n && (t === Z ? D() : n === Z && D(!0));
	        }), x(l + "." + Z, function () {
	          D();
	        });
	      }, getIframe: function getIframe(n, i) {
	        var o = n.src,
	            r = t.st.iframe;e.each(r.patterns, function () {
	          return o.indexOf(this.index) > -1 ? (this.id && (o = "string" == typeof this.id ? o.substr(o.lastIndexOf(this.id) + this.id.length, o.length) : this.id.call(this, o)), o = this.src.replace("%id%", o), !1) : void 0;
	        });var a = {};return r.srcAction && (a[r.srcAction] = o), t._parseMarkup(i, a, n), t.updateStatus("ready"), i;
	      } } });var K = function K(e) {
	    var n = t.items.length;return e > n - 1 ? e - n : 0 > e ? n + e : e;
	  },
	      Y = function Y(e, t, n) {
	    return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n);
	  };e.magnificPopup.registerModule("gallery", { options: { enabled: !1, arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', preload: [0, 2], navigateByImgClick: !0, arrows: !0, tPrev: "Previous (Left arrow key)", tNext: "Next (Right arrow key)", tCounter: "%curr% of %total%" }, proto: { initGallery: function initGallery() {
	        var n = t.st.gallery,
	            i = ".mfp-gallery",
	            r = Boolean(e.fn.mfpFastClick);return t.direction = !0, n && n.enabled ? (a += " mfp-gallery", x(f + i, function () {
	          n.navigateByImgClick && t.wrap.on("click" + i, ".mfp-img", function () {
	            return t.items.length > 1 ? (t.next(), !1) : void 0;
	          }), o.on("keydown" + i, function (e) {
	            37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next();
	          });
	        }), x("UpdateStatus" + i, function (e, n) {
	          n.text && (n.text = Y(n.text, t.currItem.index, t.items.length));
	        }), x(p + i, function (e, i, o, r) {
	          var a = t.items.length;o.counter = a > 1 ? Y(n.tCounter, r.index, a) : "";
	        }), x("BuildControls" + i, function () {
	          if (t.items.length > 1 && n.arrows && !t.arrowLeft) {
	            var i = n.arrowMarkup,
	                o = t.arrowLeft = e(i.replace(/%title%/gi, n.tPrev).replace(/%dir%/gi, "left")).addClass(y),
	                a = t.arrowRight = e(i.replace(/%title%/gi, n.tNext).replace(/%dir%/gi, "right")).addClass(y),
	                s = r ? "mfpFastClick" : "click";o[s](function () {
	              t.prev();
	            }), a[s](function () {
	              t.next();
	            }), t.isIE7 && (k("b", o[0], !1, !0), k("a", o[0], !1, !0), k("b", a[0], !1, !0), k("a", a[0], !1, !0)), t.container.append(o.add(a));
	          }
	        }), x(m + i, function () {
	          t._preloadTimeout && clearTimeout(t._preloadTimeout), t._preloadTimeout = setTimeout(function () {
	            t.preloadNearbyImages(), t._preloadTimeout = null;
	          }, 16);
	        }), x(l + i, function () {
	          o.off(i), t.wrap.off("click" + i), t.arrowLeft && r && t.arrowLeft.add(t.arrowRight).destroyMfpFastClick(), t.arrowRight = t.arrowLeft = null;
	        }), void 0) : !1;
	      }, next: function next() {
	        t.direction = !0, t.index = K(t.index + 1), t.updateItemHTML();
	      }, prev: function prev() {
	        t.direction = !1, t.index = K(t.index - 1), t.updateItemHTML();
	      }, goTo: function goTo(e) {
	        t.direction = e >= t.index, t.index = e, t.updateItemHTML();
	      }, preloadNearbyImages: function preloadNearbyImages() {
	        var e,
	            n = t.st.gallery.preload,
	            i = Math.min(n[0], t.items.length),
	            o = Math.min(n[1], t.items.length);for (e = 1; (t.direction ? o : i) >= e; e++) {
	          t._preloadItem(t.index + e);
	        }for (e = 1; (t.direction ? i : o) >= e; e++) {
	          t._preloadItem(t.index - e);
	        }
	      }, _preloadItem: function _preloadItem(n) {
	        if (n = K(n), !t.items[n].preloaded) {
	          var i = t.items[n];i.parsed || (i = t.parseEl(n)), T("LazyLoad", i), "image" === i.type && (i.img = e('<img class="mfp-img" />').on("load.mfploader", function () {
	            i.hasSize = !0;
	          }).on("error.mfploader", function () {
	            i.hasSize = !0, i.loadError = !0, T("LazyLoadError", i);
	          }).attr("src", i.src)), i.preloaded = !0;
	        }
	      } } });var U = "retina";e.magnificPopup.registerModule(U, { options: { replaceSrc: function replaceSrc(e) {
	        return e.src.replace(/\.\w+$/, function (e) {
	          return "@2x" + e;
	        });
	      }, ratio: 1 }, proto: { initRetina: function initRetina() {
	        if (window.devicePixelRatio > 1) {
	          var e = t.st.retina,
	              n = e.ratio;n = isNaN(n) ? n() : n, n > 1 && (x("ImageHasSize." + U, function (e, t) {
	            t.img.css({ "max-width": t.img[0].naturalWidth / n, width: "100%" });
	          }), x("ElementParse." + U, function (t, i) {
	            i.src = e.replaceSrc(i, n);
	          }));
	        }
	      } } }), function () {
	    var t = 1e3,
	        n = "ontouchstart" in window,
	        i = function i() {
	      I.off("touchmove" + r + " touchend" + r);
	    },
	        o = "mfpFastClick",
	        r = "." + o;e.fn.mfpFastClick = function (o) {
	      return e(this).each(function () {
	        var a,
	            s = e(this);if (n) {
	          var l, c, d, u, p, f;s.on("touchstart" + r, function (e) {
	            u = !1, f = 1, p = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0], c = p.clientX, d = p.clientY, I.on("touchmove" + r, function (e) {
	              p = e.originalEvent ? e.originalEvent.touches : e.touches, f = p.length, p = p[0], (Math.abs(p.clientX - c) > 10 || Math.abs(p.clientY - d) > 10) && (u = !0, i());
	            }).on("touchend" + r, function (e) {
	              i(), u || f > 1 || (a = !0, e.preventDefault(), clearTimeout(l), l = setTimeout(function () {
	                a = !1;
	              }, t), o());
	            });
	          });
	        }s.on("click" + r, function () {
	          a || o();
	        });
	      });
	    }, e.fn.destroyMfpFastClick = function () {
	      e(this).off("touchstart" + r + " click" + r), n && I.off("touchmove" + r + " touchend" + r);
	    };
	  }(), _();
	})(__webpack_provided_window_dot_jQuery || window.Zepto);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	/*
	Plugin: jQuery Parallax
	Version 1.1.3
	Author: Ian Lunn
	Twitter: @IanLunn
	Author URL: http://www.ianlunn.co.uk/
	Plugin URL: http://www.ianlunn.co.uk/plugins/jquery-parallax/
	
	Dual licensed under the MIT and GPL licenses:
	http://www.opensource.org/licenses/mit-license.php
	http://www.gnu.org/licenses/gpl.html
	*/
	
	(function ($) {
		var $window = $(window);
		var windowHeight = $window.height();
	
		$window.resize(function () {
			windowHeight = $window.height();
		});
	
		$.fn.parallax = function (xpos, speedFactor, outerHeight) {
			var $this = $(this);
			var getHeight;
			var firstTop;
			var paddingTop = 0;
	
			//get the starting position of each element to have parallax applied to it	
			function update() {
	
				$this.each(function () {
					firstTop = $this.offset().top;
				});
	
				if (outerHeight) {
					getHeight = function getHeight(jqo) {
						return jqo.outerHeight(true);
					};
				} else {
					getHeight = function getHeight(jqo) {
						return jqo.height();
					};
				}
	
				// setup defaults if arguments aren't specified
				if (arguments.length < 1 || xpos === null) xpos = "50%";
				if (arguments.length < 2 || speedFactor === null) speedFactor = 0.4;
				if (arguments.length < 3 || outerHeight === null) outerHeight = true;
	
				// function to be called whenever the window is scrolled or resized
	
				var pos = $window.scrollTop();
	
				$this.each(function () {
					var $element = $(this);
					var top = $element.offset().top;
					var height = getHeight($element);
	
					// Check if totally above or totally below viewport
					if (top + height < pos || top > pos + windowHeight) {
						return;
					}
	
					$this.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px");
				});
			}
	
			$window.bind('scroll', update).resize(update);
			update();
		};
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Flaticon;src:url(" + __webpack_require__(5) + ");src:url(" + __webpack_require__(5) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(31) + ") format(\"svg\"),url(" + __webpack_require__(28) + ") format(\"woff\"),url(" + __webpack_require__(27) + ") format(\"truetype\");font-weight:400;font-style:normal}[class*=\" flaticon-\"]:after,[class*=\" flaticon-\"]:before,[class^=flaticon-]:after,[class^=flaticon-]:before{font-family:Flaticon;font-size:3pc;font-style:normal;margin-left:20px}.flaticon-couple59:before{content:\"\\E000\"}.flaticon-event5:before{content:\"\\E001\"}.flaticon-guestbook:before{content:\"\\E002\"}.flaticon-invitation:before{content:\"\\E003\"}.flaticon-little8:before{content:\"\\E004\"}.flaticon-man204:before{content:\"\\E005\"}.flaticon-man209:before{content:\"\\E006\"}.flaticon-person122:before{content:\"\\E007\"}.flaticon-person123:before{content:\"\\E008\"}.flaticon-present2:before{content:\"\\E009\"}.flaticon-quill1:before{content:\"\\E00A\"}.flaticon-recognition6:before{content:\"\\E00B\"}.flaticon-slr2:before{content:\"\\E00C\"}.flaticon-social19:before{content:\"\\E00D\"}.flaticon-vintage2:before{content:\"\\E00E\"}", ""]);
	
	// exports


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.1.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(20) + ");src:url(" + __webpack_require__(19) + "?#iefix&v=4.1.0) format('embedded-opentype'),url(" + __webpack_require__(30) + ") format('woff'),url(" + __webpack_require__(29) + ") format('truetype'),url(" + __webpack_require__(32) + "#fontawesomeregular) format('svg');font-weight:400;font-style:normal}.fa{display:inline-block;font-family:FontAwesome;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:spin 4s infinite linear;animation:spin 4s infinite linear}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);-webkit-transform:scale(1,-1);transform:scale(1,-1)}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-square:before,.fa-pied-piper:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}", ""]);
	
	// exports


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}table{border-collapse:collapse;border-spacing:0}nav ul{list-style:none}.clearfix:after,.clearfix:before,.row:after,.row:before{content:\" \";display:table}.clearfix:after,.row:after{clear:both}.clearfix,.row{*zoom:1}*,:after,:before{box-sizing:border-box}html{-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}img{-ms-interpolation-mode:bicubic;height:auto;margin:0;max-width:100%}.alignleft,.alignleft img,.alignright img,img.alignleft{float:left}.alignright,img.alignright{float:right}.aligncenter,img.aligncenter{clear:both;display:block;margin-left:auto;margin-right:auto}.wp-caption-text{clear:both}li.widget{list-style:none}button,input[type=button],input[type=checkbox],input[type=radio],input[type=reset],input[type=submit],label,select{font-family:Quicksand,Arial,sans-serif;font-size:13px;cursor:pointer}input[type=email]:focus,input[type=text]:focus,input[type=url]:focus,textarea:focus{border-color:#888;outline:0}textarea{min-height:50px;overflow:auto}select:focus{outline:thin dotted #333;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}select{width:100%;height:2pc}input,select,textarea{font-family:Quicksand,Arial,sans-serif;font-size:1pc;font-weight:100;border-radius:5px;outline:0;display:block;max-width:100%;padding:6px 15px;border:1px solid #ddd;margin-bottom:15px;background:transparent;color:gray;-webkit-transition:all .4s ease-in-out;-moz-transition:all .4s ease-in-out;-ms-transition:all .4s ease-in-out;-o-transition:all .4s ease-in-out}fieldset{margin:0}fieldset,legend{border:0;padding:0}legend{*margin-left:-7px}button,input,select,textarea{font-size:100%;margin:0;vertical-align:baseline;*vertical-align:middle}button,input{line-height:normal;*overflow:visible}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}button,input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:none;cursor:pointer;-webkit-transition:.4s;transition:.4s}.container{margin:0 auto;max-width:855pt;width:90%}.column{margin-bottom:1.5em}@media (min-width:669px){.row .row{margin-left:-15px;margin-right:-15px}.column{float:left;margin:0;padding-left:15px;padding-right:15px}.column.flow-opposite{float:right}.column.one{width:8.33333%}.column.two{width:16.66667%}.column.three{width:25%}.column.four{width:33.33333%}.column.five{width:41.66667%}.column.six{width:50%}.column.seven{width:58.33333%}.column.eight{width:66.66667%}.column.nine{width:75%}.column.ten{width:83.33333%}.column.eleven{width:91.66667%}.column.twelve{width:100%}}", ""]);
	
	// exports


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".mfp-bg{z-index:1042;overflow:hidden;background:#0b0b0b;opacity:.8;filter:alpha(opacity=80)}.mfp-bg,.mfp-wrap{top:0;left:0;width:100%;height:100%;position:fixed}.mfp-wrap{z-index:1043;outline:0!important;-webkit-backface-visibility:hidden}.mfp-container{text-align:center;position:absolute;width:100%;height:100%;left:0;top:0;padding:0 8px;box-sizing:border-box}.mfp-container:before{content:'';display:inline-block;height:100%;vertical-align:middle}.mfp-align-top .mfp-container:before{display:none}.mfp-content{position:relative;display:inline-block;vertical-align:middle;margin:0 auto;text-align:left;z-index:1045}.mfp-ajax-holder .mfp-content,.mfp-inline-holder .mfp-content{width:100%;cursor:auto}.mfp-ajax-cur{cursor:progress}.mfp-zoom-out-cur,.mfp-zoom-out-cur .mfp-image-holder .mfp-close{cursor:zoom-out}.mfp-zoom{cursor:pointer;cursor:zoom-in}.mfp-auto-cursor .mfp-content{cursor:auto}.mfp-arrow,.mfp-close,.mfp-counter,.mfp-preloader{-webkit-user-select:none;-moz-user-select:none;user-select:none}.mfp-loading.mfp-figure{display:none}.mfp-hide{display:none!important}.mfp-preloader{color:#ccc;position:absolute;top:50%;width:auto;text-align:center;margin-top:-.8em;left:8px;right:8px;z-index:1044}.mfp-preloader a{color:#ccc}.mfp-preloader a:hover{color:#fff}.mfp-s-error .mfp-content,.mfp-s-ready .mfp-preloader{display:none}button.mfp-arrow,button.mfp-close{overflow:visible;cursor:pointer;background:transparent;border:0;-webkit-appearance:none;display:block;outline:0;padding:0;z-index:1046;box-shadow:none}button::-moz-focus-inner{padding:0;border:0}.mfp-close{width:44px;height:44px;line-height:44px;position:absolute;right:0;top:0;text-decoration:none;text-align:center;opacity:.65;filter:alpha(opacity=65);padding:0 0 18px 10px;color:#fff;font-style:normal;font-size:28px;font-family:Arial,Baskerville,monospace}.mfp-close:focus,.mfp-close:hover{opacity:1;filter:alpha(opacity=100)}.mfp-close:active{top:1px}.mfp-close-btn-in .mfp-close{color:#333}.mfp-iframe-holder .mfp-close,.mfp-image-holder .mfp-close{color:#fff;right:-6px;text-align:right;padding-right:6px;width:100%}.mfp-counter{position:absolute;top:0;right:0;color:#ccc;font-size:9pt;line-height:18px}.mfp-arrow{position:absolute;opacity:.65;filter:alpha(opacity=65);margin:0;top:50%;margin-top:-55px;padding:0;width:90px;height:110px;-webkit-tap-highlight-color:rgba(0,0,0,0)}.mfp-arrow:active{margin-top:-54px}.mfp-arrow:focus,.mfp-arrow:hover{opacity:1;filter:alpha(opacity=100)}.mfp-arrow .mfp-a,.mfp-arrow .mfp-b,.mfp-arrow:after,.mfp-arrow:before{content:'';display:block;width:0;height:0;position:absolute;left:0;top:0;margin-top:35px;margin-left:35px;border:medium inset transparent}.mfp-arrow .mfp-a,.mfp-arrow:after{border-top-width:13px;border-bottom-width:13px;top:8px}.mfp-arrow .mfp-b,.mfp-arrow:before{border-top-width:21px;border-bottom-width:21px;opacity:.7}.mfp-arrow-left{left:0}.mfp-arrow-left .mfp-a,.mfp-arrow-left:after{border-right:17px solid #fff;margin-left:31px}.mfp-arrow-left .mfp-b,.mfp-arrow-left:before{margin-left:25px;border-right:27px solid #3f3f3f}.mfp-arrow-right{right:0}.mfp-arrow-right .mfp-a,.mfp-arrow-right:after{border-left:17px solid #fff;margin-left:39px}.mfp-arrow-right .mfp-b,.mfp-arrow-right:before{border-left:27px solid #3f3f3f}.mfp-iframe-holder{padding-top:40px;padding-bottom:40px}.mfp-iframe-holder .mfp-content{line-height:0;width:100%;max-width:900px}.mfp-iframe-holder .mfp-close{top:-40px}.mfp-iframe-scaler{width:100%;height:0;overflow:hidden;padding-top:56.25%}.mfp-iframe-scaler iframe{position:absolute;display:block;top:0;left:0;width:100%;height:100%;box-shadow:0 0 8px rgba(0,0,0,.6);background:#000}img.mfp-img{width:auto;max-width:100%;height:auto;display:block;box-sizing:border-box;padding:40px 0;margin:0 auto}.mfp-figure,img.mfp-img{line-height:0}.mfp-figure:after{content:'';position:absolute;left:0;top:40px;bottom:40px;display:block;right:0;width:auto;height:auto;z-index:-1;box-shadow:0 0 8px rgba(0,0,0,.6);background:#444}.mfp-figure small{color:#bdbdbd;display:block;font-size:9pt;line-height:14px}.mfp-figure figure{margin:0}.mfp-bottom-bar{margin-top:-36px;position:absolute;top:100%;left:0;width:100%;cursor:auto}.mfp-title{text-align:left;line-height:18px;color:#f3f3f3;word-wrap:break-word;padding-right:36px}.mfp-image-holder .mfp-content{max-width:100%}.mfp-gallery .mfp-image-holder .mfp-figure{cursor:pointer}@media screen and (max-height:300px),screen and (max-width:800px) and (orientation:landscape){.mfp-img-mobile .mfp-image-holder{padding-left:0;padding-right:0}.mfp-img-mobile img.mfp-img{padding:0}.mfp-img-mobile .mfp-figure:after{top:0;bottom:0}.mfp-img-mobile .mfp-figure small{display:inline;margin-left:5px}.mfp-img-mobile .mfp-bottom-bar{background:rgba(0,0,0,.6);bottom:0;margin:0;top:auto;padding:3px 5px;position:fixed;box-sizing:border-box}.mfp-img-mobile .mfp-bottom-bar:empty{padding:0}.mfp-img-mobile .mfp-counter{right:5px;top:3px}.mfp-img-mobile .mfp-close{top:0;right:0;width:35px;height:35px;line-height:35px;background:rgba(0,0,0,.6);position:fixed;text-align:center;padding:0}}@media all and (max-width:900px){.mfp-arrow{-webkit-transform:scale(0.75);transform:scale(0.75)}.mfp-arrow-left{-webkit-transform-origin:0;transform-origin:0}.mfp-arrow-right{-webkit-transform-origin:100%;transform-origin:100%}.mfp-container{padding-left:6px;padding-right:6px}}.mfp-ie7 .mfp-img{padding:0}.mfp-ie7 .mfp-bottom-bar{width:600px;left:50%;margin-left:-300px;margin-top:5px;padding-bottom:5px}.mfp-ie7 .mfp-container{padding:0}.mfp-ie7 .mfp-content{padding-top:44px}.mfp-ie7 .mfp-close{top:0;right:0;padding-top:0}", ""]);
	
	// exports


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "body{background-color:#faf8f0;background-image:url(" + __webpack_require__(4) + ");background-repeat:repeat}section{clear:both}.hero{min-height:500px;background-image:url(" + __webpack_require__(18) + ")}#gallery-wrapper>div{float:left;max-height:85px}#gallery-wrapper .portfolio-title{padding:0}.small-gallery-wrapper{bottom:-85px}", ""]);
	
	// exports


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "body,html{height:100%}body{margin:0;padding:0;width:100%;font:1pc/28px \"Quicksand\",Helvetica,Arial,sans-serif;color:#666;-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%}h1,h2,h3,h4,h5,h6{font-family:Quicksand,sans-serif;color:#ff8c89;margin-bottom:25px;font-weight:700}h1 a,h2 a,h3 a,h4 a,h5 a,h6 a{font-weight:inherit;color:#d9c6b1}h1{font-size:41px}h2{font-size:2pc;line-height:40px}h3{font-size:22px;line-height:29px}h4{font-size:18px;line-height:21px}h5{font-size:14px;line-height:18px}h6{font-size:9pt;line-height:1pc}p{margin:0 0 25px}p img{margin:0}a{text-decoration:none;-webkit-transform:translateZ(0);-webkit-transition:.3s all linear;transition:.3s all linear}a,a:active,a:hover{color:#ff8c89;outline:0}em,i{font-style:italic}b,strong{font-weight:700}small{font-size:80%}address{font-style:normal}ol,ul{margin-bottom:20px}ul{list-style:none outside}ol{list-style:decimal}ul.square{list-style:square outside}ul.disc{list-style:disc outside}ol ol,ol ul,ul ol,ul ul{margin-left:30px}ol ol li,ol ul li,ul ol li,ul ul li{margin-bottom:0}blockquote,q{quotes:none;font-size:26px;line-height:42px}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}#page-content blockquote{font-size:21px;line-height:31px;padding-left:20px;border-left:3px solid #ff8c89;margin:20px 0}hr{border:solid #efe7df;border-width:1px 0 0;clear:both;margin:20px 0 40px;height:0}img{height:auto}iframe,img{max-width:100%}@media \\0screen{img{width:auto}}section{padding:150px 0 5pc}section section{background-color:#fff}.spacer{height:5pc}#wedding-events .timeline .column.heart:after,.pattern{background-color:#faf8f0;background-image:url(" + __webpack_require__(4) + ");background-repeat:repeat}.box.pattern{background-color:#faf8f0;background-image:none!important}.bgcolor{background-color:#ff8c89;background-image:url(" + __webpack_require__(4) + ");background-repeat:repeat}.nobottom-padding{padding-bottom:0}.hide{display:none!important;visibility:hidden}.left{text-align:left}.right{text-align:right}.gray{background-color:#f3f3f3}#portfolio-title,.section-title{text-align:center}.vibe{font:46px/58px 'Great Vibes',cursive}h3.section-title{position:relative;text-transform:uppercase;color:#d9c6b1}h3.section-title:before{position:absolute;top:-70px;left:50%;margin-left:-19px;font-weight:400;font-family:Flaticon;font-size:3pc;color:#d9c6b1}.section-tagline{font-size:1pc;max-width:700px;margin:auto auto 5pc;color:#666;line-height:28px;text-align:center}a.more{color:#d9c6b1;font-size:14px;font-weight:700}span.fill{background-color:#ff8c89;color:#fff;padding:2px 4px}.overlay{background:rgba(255,119,120,.45)}.overlay,.overlay-dark{position:absolute;top:0;left:0;width:100%;height:100%;filter:progid: DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#7c000000',endColorstr='#7c000000')}.overlay-dark{background:rgba(25,25,25,.16)}a.button{position:relative;display:inline-block;background-color:#faf8f0;padding:2px 20px;border-radius:50px;box-shadow:0 3px 0 #d9c6b1;font-size:14px;font-weight:700;margin:5px;-webkit-transition:all .1s;transition:all .1s}a.button:active{box-shadow:0 0 0 #d9c6b1;top:2px}a.button.fill{background:#ff8c89;color:#fff}a.button.lb{font-size:15px;padding:9pt 50px}a.button i{margin-right:5px}.timeline{position:relative;padding:0;margin:0 auto}.timeline:before{position:absolute;top:0;width:1px;height:100%;left:50%;content:'';background-color:#d9c6b1}.timeline .column{position:relative}.timeline .column.heart:after{content:'\\F004';font-family:FontAwesome;font-size:20px;position:absolute;top:36px;color:#ff8c89;background-color:#fff}.timeline .movetop{margin-top:75pt}.timeline .column.right:after{right:-11px}.timeline .column.left:after{left:-9px}.timeline .column .box:after{content:'';position:absolute;width:30px;height:19px;background-repeat:no-repeat;top:30px}.timeline .column.left .box:after{left:-22px}.timeline .column.right .box:after{right:-22px}.column.left{padding-left:5pc;float:right;clear:right}.column.right{padding-right:5pc}.timeline-year{position:relative;text-align:center;margin:0 0 30px}.timeline-year.start{margin-top:60px}.timeline-year span{font-size:14px;font-weight:700;background-color:#ff8c89;padding:8px 20px;border-radius:25px;color:#fff}.timeline-button{text-align:center}.timeline-button a{color:#d9c6b1}.arrow-up{width:17px;height:22px;top:4px;margin-left:-8px}.arrow-down,.arrow-up{position:absolute;left:50%}.arrow-down{width:19px;height:11px;bottom:-1px;margin-left:-9px}.mfp-zoom-out-cur,.mfp-zoom-out-cur .mfp-image-holder .mfp-close{cursor:zoom-out}.mfp-zoom{cursor:pointer;cursor:zoom-in}.mfp-loading.mfp-figure{display:none}.mfp-hide{display:none!important}.mfp-preloader{position:absolute;left:50%;top:50%;opacity:0;border:3px solid #222;border-radius:30px;z-index:999;text-indent:-9999px;width:50px;height:50px;margin-top:-25px;margin-left:-25px;-webkit-animation:pulsing 1s ease-out infinite;animation:pulsing 1s ease-out infinite}@-webkit-keyframes pulsing{0%{-webkit-transform:scale(.1);opacity:0}50%{opacity:1}to{-webkit-transform:scale(1.2)}}@keyframes pulsing{0%,to{opacity:0}0%{transform:scale(.1)}50%{opacity:1}to{transform:scale(1.2);opacity:0}}.mfp-s-error .mfp-content,.mfp-s-ready .mfp-preloader{display:none}#qLoverlay{background-color:#111;position:fixed;z-index:666999;top:0;left:0;width:100%;height:100%}.queryloader__overlay__bar{top:0!important}#qLpercentage{line-height:46px;margin-top:-23px!important}.mfp-content{margin-top:-75px}.mfp-title{display:inline-block;text-align:left;padding:15px 0}.small-gallery img{height:75px;float:left;opacity:.3;cursor:pointer}.small-gallery-wrapper{position:absolute;bottom:-95px;width:100%;overflow:hidden}.small-gallery .active{opacity:1}.small-gallery{width:625pc;position:relative;transition:left .4s}.mfp-bg{opacity:.9;background:#000}.mfp-counter{position:static;display:inline-block;float:right;padding:15px 0;font-size:1pc}.mfp-arrow-left:before{content:'\\F104';font-family:FontAwesome;border:none;color:#fff;font-size:42px}.mfp-arrow-left:after{border:none}.mfp-arrow-right:before{content:'\\F105';font-family:FontAwesome;border:none;color:#fff;font-size:42px}.mfp-arrow-right:after{border:none}.loaderOverlay{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1000;display:table;background:#fff}.loaderOverlay i{display:table-cell;vertical-align:middle;font-size:45px;-webkit-animation:pulsing 1.2s infinite;animation:pulsing 1.2s infinite}#logo,.loaderOverlay i{text-align:center;color:#ff8c89}#logo{position:relative;height:5pc;background-color:#fff;text-transform:uppercase;display:block;font:28px/5pc 'Playfair Display',serif;letter-spacing:3px}#logo span{color:#d9c6b1;font-size:38px;vertical-align:bottom}.hero{position:relative;overflow:hidden;width:100%;padding:0;background-position:center center;background-size:cover!important;background-repeat:no-repeat!important}#background-image.not-mobile,.hero.not-mobile,.parallax.not-mobile{background-attachment:fixed}.hero h1{font:94px/86px 'Great Vibes',cursive}.hero #main-menu{border-top:1px solid #f3f3f3}.hero .container{display:table;height:100%}.hero-inner{text-align:center;z-index:9;display:table-cell;vertical-align:middle;position:relative;width:100%}.hero h1{margin:10px 0;color:#fff;font-size:94px}.hero #countdown:before{position:absolute;content:'';width:50px;height:1px;background-color:#fff;top:-9pt;left:50%;margin-left:-25px}.hero #countdown:after{position:absolute;content:'\\25CF';top:-39px;font-size:21px;left:50%;margin-left:-6px}.hero #countdown{position:absolute;display:inline-block;line-height:52px;font-size:28px;color:#fff;bottom:90px;left:0;right:0;font-weight:100}.hero #countdown span{font-family:Playfair Display,serif;font-style:italic;font-size:1pc;margin:0 15px 0 5px;letter-spacing:2px}.hero .info .date{position:absolute;left:0;right:0;bottom:180px;font-family:Playfair Display,serif;font-style:italic;text-align:center;font-size:18px;color:#fff;letter-spacing:1px}.hero-inner .mouse{display:block;position:absolute;opacity:.7;bottom:30px;border:1px solid #fff;border-radius:25px;height:36px;left:0;margin:0 auto;right:0;width:24px;cursor:pointer;-webkit-transition:all .3s linear;transition:all .9s linear}.hero-inner .mouse:hover{opacity:.3!important}.hero-inner .mouse i{display:block;-webkit-animation:1.4s ease 0s normal none infinite mouse-down;animation:1.4s ease 0s normal none infinite mouse-down;color:#fff;font-size:9pt;transform:translateZ(0)}.hero .hero-slideshow .slide{background-repeat:no-repeat;background-position:top left;background-size:cover;position:absolute;top:0;left:0;height:100%;width:100%}.hero .hero-slideshow img{display:none}@-webkit-keyframes mouse-down{0%{margin-top:4px;opacity:0}30%{opacity:1}to{margin-top:11px}}@keyframes mouse-down{0%,to{opacity:0}0%{margin-top:4px}30%{opacity:1}to{margin-top:11px;opacity:0}}#menu-logo{display:none}#main-menu{position:absolute;text-align:center;line-height:56px;height:56px;border-bottom:1px solid #efe7df;background:#fff;background:hsla(0,0%,100%,.97);width:100%;top:0;left:0;z-index:999;-webkit-transition:all .5s;transition:all .5s}#main-menu.dole{position:fixed}#main-menu ul{margin-bottom:0}#main-menu li{display:inline-block;padding:0 10px}#main-menu ul li a{display:block;padding:0 5px;color:#666;font-size:9pt;line-height:56px;text-transform:uppercase;letter-spacing:1px}#main-menu a.active,#main-menu a:hover{color:#ff8c89}#main-menu.header-hide,#main-menu.header-show{-webkit-transform:translateY(0%);transform:translateY(0%)}#main-menu.header-show{position:fixed;height:56px}#main-menu ul ul{padding-top:15px;display:none;position:absolute;margin-left:0;border-radius:6px}#main-menu li.submenu{position:relative;margin-right:5px}#main-menu li.submenu:after{position:absolute;right:0;top:0;content:'\\F107';font-family:FontAwesome;color:#bbb;-webkit-transform:translateZ(0);-webkit-transition:.3s all linear;transition:.3s all linear}#main-menu li.submenu:hover:after,#main-menu li:hover>a{color:#ff8c89}#main-menu ul ul:before{content:\"\";width:0;height:0;border-style:solid;border-width:0 7.5px 7px;border-color:transparent transparent #fff;position:absolute;top:8px;left:18px}#main-menu ul ul li{display:block;background:#fff;background:hsla(0,0%,100%,.97);line-height:2pc;height:2pc;padding:0 10px;min-width:10pc;text-align:left;white-space:nowrap}#main-menu ul ul li:first-child{padding-top:5px;height:auto;border-top-left-radius:4px;border-top-right-radius:4px}#main-menu ul ul li:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding-bottom:5px;height:auto}#main-menu ul ul li a{line-height:2pc}#navigation-dotted{position:fixed;right:50px;top:0;height:100%;z-index:999;display:table;white-space:nowrap}#navigation-dotted nav{display:table-cell;vertical-align:middle}#navigation-dotted ul li a{position:relative}#navigation-dotted ul li a:before{display:block;content:\"\";font-family:FontAwesome;font-size:18px;width:1pc;height:1pc;margin:15px 0;background:#ff8c89;border-radius:50%;border:1px solid #d9c6b1}#navigation-dotted ul li a.active:before{background:#d9c6b1;border:1px solid #d9c6b1}#navigation-dotted ul li a span{display:none;position:absolute;right:15px;height:27px;bottom:8px;padding:0 15px;text-align:right;background:#ff8c89;border-radius:6px;text-transform:uppercase;font-size:9pt;color:#fff}#navigation-dotted ul li a span:after{content:\"\";display:block;width:0;height:0;border-style:solid;border-width:7px 0 6px 7px;border-color:transparent transparent transparent #ff8c89;position:absolute;right:-6px;top:7px}#navigation-dotted ul li a:hover span{display:block}#home-content{background-color:#fff;position:relative;padding:56px 0 0}#home-content.dotted-menu,#home-content.top-menu{padding:0}#invitation{padding:60px 0;text-align:center}#invitation span{display:block;font-size:22px;font-weight:700;color:#d9c6b1}#invitation a{font-size:15px;font-weight:700;display:inline-block;background:#ff8c89;margin-top:25px;color:#fff;padding:10px 45px}#couple{padding:0}#couple,#couple .images>div{position:relative;overflow:hidden}#couple .images>div{background-position:center center;background-size:cover;background-repeat:no-repeat;height:380px;margin-bottom:0}#couple .hero-heart{position:absolute;width:113px;height:109px;top:150px;left:50%;margin-left:-56px;z-index:9}#couple .images .column>span{position:absolute;top:10pc;right:65px;z-index:9}#couple .fname{color:#d9c6b1;font-family:Playfair Display,serif;font-size:4pc;text-transform:uppercase;letter-spacing:10px}#couple .images .column .lname{color:#fff;font-size:24px;letter-spacing:2px;text-transform:uppercase;font-weight:100;right:5pc}#couple .images .column>span.lname{top:220px}#couple .images .column.boy>span{left:70px;right:auto}#couple .overlay-dark{z-index:2}#story{padding-top:5pc}#story .quote{font:26px/46px 'Playfair Display',serif;margin:40px auto;padding:60px 10pc}.social ul li{display:inline-block;margin:0 5px}.social ul li a{color:#d9c6b1;font-size:20px}.social ul li a:hover{color:#ff8c89}#loveline h3.section-title:before{content:\"\\E000\";top:-60px;font-size:78px;margin-left:-40px}#loveline .timeline{padding-bottom:40px}.box{position:relative;background:#fff;padding:25px 35px;margin:10px;margin-bottom:60px;font-size:14px;line-height:24px;border-radius:6px}.box h2{font-family:Playfair Display,serif;font-weight:300}.box a{color:#d9c6b1}.box a:hover{color:#ff8c89}.box p{margin-bottom:20px}.box .date{position:absolute;width:100%;right:0;top:-35px;font-family:Playfair Display,serif;font-style:italic}.box .date:before{content:'\\F073';font-family:FontAwesome;font-size:14px;margin-right:10px;color:#ff8c89;font-style:normal}.box.corner .date{right:35px}.left .box.corner .date{right:-35px}.box .box-content{position:relative;z-index:9}.box .box-content iframe,.box .box-content img{margin-bottom:20px}.box .box-content .gallery img{max-height:3pc;margin:0 3px 20px}.box.corner,.small-box.corner li{border-radius:50px}.box.corner:before{content:'';position:absolute;border:1px solid #efe7df;top:7px;left:7px;bottom:7px;right:7px}.box.corner:before,.small-box .product{border-radius:25px}.corners-topright{right:0}.corners-topleft,.corners-topright{position:absolute;width:45px;height:45px;top:0}.corners-topleft{content:'';left:0;-webkit-transform:rotate(270deg);transform:rotate(270deg)}.corners-bottomright{right:0}.corners-bottomleft,.corners-bottomright{position:absolute;width:45px;height:45px;bottom:0}.corners-bottomleft{content:'';left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.box.quote{font:1pc/26px 'Playfair Display',serif;text-align:center;padding:45px 10pc;color:#d9c6b1;margin-bottom:60px;margin-top:-180px}.box.quote span{display:block}.box.quote.intimeline{margin-top:5pc}.parallax .container{display:table;height:100%}.parallax{position:relative;overflow:hidden;width:100%;height:5in;background-position:center center;background-size:cover!important;background-repeat:no-repeat!important;padding:0}.parallax h2.quote{position:relative;height:100%;display:table-cell;vertical-align:middle;color:#fff;text-align:center;font:34px/56px 'Playfair Display',serif}#wedding-events h3.section-title:before{content:\"\\E009\";margin-left:-21px;font-size:46px}.box.center{text-align:center;padding:50px 35px}.details{margin:50px 0 25px;position:relative}.details:before{position:absolute;content:'';width:50px;height:1px;background-color:#d9c6b1;top:-25px;left:50%;margin-left:-25px}.details:after{position:absolute;content:'\\25CF';color:#d9c6b1;top:-38px;font-size:1pc;left:50%;margin-left:-5px}.details span,.quote span{font-family:Playfair Display,serif;letter-spacing:1px;display:block;color:#8f8f8f}.details span.waddress,.quote span.waddress{font-weight:700}#important-people h3.section-title:before{margin-left:-26px;font-size:56px;content:\"\\E005\"}#important-people .tab-content h2{font-family:Playfair Display,serif;font-weight:300;margin:15px 0;color:#d9c6b1}.people-image img{opacity:.3;max-width:111px;border-radius:50%}.people-image li{margin:0 7px;list-style:none;display:inline-block}.people-image li:first-child{margin-left:0}.people-image li:last-child{margin-right:0}.people-image li.active a img{opacity:1}#wedding-gallery{padding-bottom:0}#wedding-gallery h3.section-title:before{margin-left:-17px;font-size:38px;content:\"\\E00C\"}#gallery-filter{text-align:center;line-height:90px;margin-bottom:0}#gallery-filter li{display:inline-block;line-height:14px;margin:0 5px}#gallery-filter li:last-child{border-right:0}#gallery-filter li a{font-size:14px;color:#666;padding:8px 15px;letter-spacing:1px}#gallery-filter li a:hover,#gallery-filter li.active a{background-color:#fff;padding:8px 15px;border-radius:6px}#gallery-wrapper>div{width:10%;overflow:hidden;position:relative}#gallery-wrapper>div img{width:100%;display:block;margin:0}#gallery-wrapper>.block.gallery img{position:absolute;z-index:1;top:0}#gallery-wrapper>.block img{backface-visibility:hidden;-webkit-transition:all .7s;transition:all .7s;transform:scale(1.1) rotate(0.1deg);-ms-transform:scale(1.1) rotate(0.1deg);-webkit-transform:scale(1.1) rotate(0.1deg);-o-transform:scale(1.1) rotate(0.1deg);-moz-transform:scale(1.1) rotate(0.1deg)}#gallery-wrapper .block .portfolio-hover,#gallery-wrapper .block .video-hover{position:absolute;top:0;bottom:0;left:0;right:0;opacity:0;text-align:center;background:hsla(2,100%,77%,.7);-webkit-transition:opacity .4s ease 0s;transition:opacity .4s ease 0s;cursor:pointer;z-index:5;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0)}#gallery-wrapper .block .portfolio-info{position:absolute;display:table;width:100%;height:100%}#gallery-wrapper .block:hover .portfolio-hover,#gallery-wrapper .block:hover .video-hover{opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=95)\";filter:alpha(opacity=95)}#gallery-wrapper .portfolio-title{display:table-cell;height:100%;vertical-align:middle;color:#fff;text-transform:uppercase;font-size:1pc;padding:0 35px}#gallery-wrapper .portfolio-title span{display:block;color:#fff;font-size:9pt}.load-more{margin-top:55px;text-align:center}.load-more a{color:#d9c6b1}.isotope,.isotope .isotope-item{-webkit-transition-duration:.4s;transition-duration:.4s}.isotope{-webkit-transition-property:height,width;transition-property:height,width}.isotope .isotope-item{-webkit-transition-property:-webkit-transform,opacity;transition-property:transform,opacity}#twitter h3.section-title:before{content:\"\\E00D\";font-size:40px}#twitter .vibe{margin-bottom:0}#twitter .tweet{font-size:14px;margin-top:25px}#twitter .time{font-size:9pt}#twitter .follow,#twitter .time{display:block;text-transform:uppercase}#twitter .follow{margin-top:55px;font-weight:700;color:#d9c6b1}#twitter .follow:hover{color:#ff8c89}#gift-registry h3.section-title:before{content:\"\\E009\"}.small-box{text-align:center;margin-top:25px;margin-bottom:0}.small-box li{position:relative;display:inline-block;width:10pc;height:150px;margin:10px;padding:7px;background:#fff}.small-box li a.product{display:inline-block;width:100%;height:100%;line-height:130px;border:1px solid #efe7df;text-align:center}.small-box li a img{vertical-align:middle}.small-box .money{border:1px solid #efe7df;height:100%;border-radius:25px}.small-box .amount{display:inline-block;margin-top:20px;font:28px/2pc 'Playfair Display',serif;font-style:italic;font-weight:700;color:#ff8c89}.small-box .donate{position:absolute;bottom:35px;left:27px;z-index:999;color:#d9c6b1}.small-box .donate:hover{color:#ff8c89}.small-box .donate:active{top:76px}#instagram-section{text-align:center}#instagram-section h3.section-title:before{content:\"\\E00E\";font-size:44px}#instagram-section .section-tagline{margin-bottom:60px}#instagram-section .hash{display:inline-block;margin-bottom:50px;border-radius:6px;background-color:#fff;padding:15px 25px;color:#ff8c89;font-size:25px}#instagram-section img{margin:20px;width:110px;border-radius:50%}.instagram-images{margin:auto;max-width:770px;font-size:0}#guestbook h3.section-title:before{font-size:72px;margin-left:-35px;content:\"\\E002\"}#guestbook .guest{position:relative}#guestbook .name{display:block;font-size:1pc;font-weight:700}#guestbook img{display:block;margin:auto;max-width:60px;margin-bottom:10px}#guestbook .timeline{padding-bottom:40px}#guestbook .form{margin-top:40px}footer{font-size:9pt;text-transform:uppercase;min-height:86px;background:#d9c6b1;color:#fff}footer a{color:#fff;font-weight:700}footer .row{padding:29px 0}footer .logo{font-size:28px;text-align:center;font-family:Playfair Display,serif}footer .logo span{margin:0 7px;font-size:38px;vertical-align:bottom;color:#ff8c89}footer .info{text-align:right}#background-image{width:100%;height:600px;background-position:center center;background-size:cover!important;background-repeat:no-repeat!important}#event-single{padding:0}header.fixed{top:0;position:fixed;width:100%;z-index:9}.page-content{padding:5pc 0}#back-home{display:block;height:56px;line-height:56px;font-size:14px;text-transform:uppercase;background:#ff8c89;color:#fff;text-align:center}#back-home:hover{-webkit-transform:translateZ(0);-webkit-transition:.3s all linear;transition:.3s all linear;background:#d9c6b1}#back-home:before{font-family:FontAwesome;content:\"\\F177\";vertical-align:bottom;font-size:18px;margin-right:10px}#title{position:relative;z-index:9;height:86px;line-height:86px;background:hsla(0,0%,100%,.97);border-bottom:1px solid #efe7df}#page-content.no-image{padding-top:220px}#title.color h1{color:#fff}#title .row .column:last-child{text-align:right}#title .six{text-align:center}#title .row .column.twelve{text-align:center;margin-bottom:0}#title .three{text-transform:uppercase}#title h1{font:34px/82px 'Playfair Display',serif;vertical-align:text-bottom;display:inline-block;margin-bottom:0}.next,.prev{color:#8e8e8e;font-size:14px}.next:hover:after,.prev:hover:before{-webkit-transition:.3s all linear;transition:.3s all linear;color:#ff8c89}.prev:before{content:\"\\F104\";margin-right:20px}.next:after,.prev:before{font-family:FontAwesome;vertical-align:top;font-size:20px;color:#ddd}.next:after{content:\"\\F105\";margin-left:20px}.page #map{height:5in;margin-top:142px}.single-page{padding:0}.content{margin-bottom:60px}.content p:first-child:first-letter{font:56px/58px 'Great Vibes',cursive;font-weight:700;float:left;line-height:84px;color:#ff8c89;margin-right:25px}.share{text-align:center}.share ul{margin-bottom:0}.share ul li{display:inline-block;margin-left:-1px}.share ul li a{display:inline-block;text-align:center;line-height:65px;width:65px;height:65px;border:1px solid #ddd;font-size:21px}.share ul li a:hover{background-color:#f3f3f3}.share a.soc-fb{color:#4b6ea6}.share a.soc-tw{color:#00b8ee}.share a.soc-gplus{color:#e36249}.share a.soc-pin{color:#d43633}#comments{position:relative;overflow:hidden;padding-top:5pc}#comments h3.section-title{margin-bottom:5pc}#comments h3.section-title span{color:#ff8c89}.container.smaller{max-width:730px}.single-comment.reply{margin-left:60px}.single-comment{position:relative;overflow:hidden;margin-bottom:25px}.single-comment h4{margin-bottom:0}.single-comment .comment-date{display:block;margin-bottom:10px;color:#d9c6b1;font-style:italic;font-family:Playfair Display,serif;font-size:14px}.single-comment p{font-size:14px;line-height:24px}.single-comment a.reply{position:absolute;top:0;right:0;color:#d9c6b1}#leave-comment{padding-top:90pt}#back-to-top{position:absolute;text-align:center;width:75pt;height:75pt;background:#ff8c89;border-radius:50%;left:50%;margin-left:-60px;bottom:-50px;-webkit-transition:all .4s;transition:all .4s}#back-to-top a{display:block;color:#fff;font-size:2pc;padding:9pt 0}#back-to-top:hover{background:#f08583}.baby{position:relative}.baby#background-image{margin-top:0;padding-bottom:60px}.baby .hero-inner .date:after{position:absolute;content:'\\25CF';color:#fff;top:-52px;font-size:1pc;left:50%;margin-left:-4px}.baby .hero-inner .date{display:block;text-align:center;margin-top:65px;position:relative;font:26px/2pc 'Playfair Display',serif;font-style:italic}#babyline h3.section-title:before{content:\"\\E004\"}#babyline .timeline{padding-bottom:40px}span.by{font-style:italic}.tabable{border:1px solid #d9c6b1}.tabable .tabs{padding:0 30px;background:#d9c6b1}.tabable .tab-content-wrap{padding:20px 30px}.tabable .tabs li{text-align:center;margin-right:30px;line-height:70px;display:inline-block;position:relative}.tabable .tabs li.active:after{content:'';position:absolute;left:50%;margin-left:-10px;bottom:-10px;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #d9c6b1}.tabable .tabs li a{text-decoration:none;text-transform:uppercase;font-size:14px;font-weight:700;color:#fff;opacity:.7}.accordion{border:1px solid #d9c6b1}.accordion .accordion-wrap .title{position:relative;border-bottom:1px solid #d9c6b1}.accordion .accordion-wrap .title:after{position:absolute;right:25px;top:20px;font-size:24px;content:\"+\";color:#d9c6b1}.accordion .accordion-wrap .title:hover:after{color:#fff}.accordion .accordion-wrap .title.active:after{content:\"-\";color:#fff}.accordion .accordion-wrap .title a:hover,.accordion .accordion-wrap .title.active,.accordion .accordion-wrap .title.active a{background:#d9c6b1;color:#fff}.accordion-wrap .contents{padding:20px 30px;border-bottom:1px solid #d9c6b1}.accordion-wrap .contents p{margin-bottom:0}.accordion .accordion-wrap .title a{display:block;padding:20px 40px 20px 30px;text-decoration:none;text-transform:uppercase;font-size:14px;font-weight:700;color:#d9c6b1}.accordion:last-child{border-bottom:0}.tabable .tabs li a:hover,.tabable .tabs li.active a{opacity:1}.errormsg,.general,.notice,.successmsg{padding:9pt 20px;text-align:left;font-size:1pc;cursor:pointer;clear:both;margin:15px 0;background-color:#d9c6b1;color:#fff;-webkit-transition:all .4s;transition:all .4s}.errormsg:before,.general:before,.notice:before,.successmsg:before{float:left;padding-right:9pt;font-family:FontAwesome;font-size:18px;width:35px}.errormsg:hover,.general:hover,.notice:hover,.successmsg:hover{opacity:.7}.successmsg:before{content:\"\\F058\"}.errormsg:before{content:\"\\F057\"}.notice:before{content:\"\\F071\"}.general:before{padding-left:5px;content:\"\\F129\"}ul.checked li:before{content:\"\\F00C\"}ul.arrow li:before,ul.checked li:before{float:left;padding-right:9pt;font-family:FontAwesome;color:#d9c6b1;font-size:14px}ul.arrow li:before{content:\"\\F054\"}ul.star li:before{content:\"\\F006\"}ul.caret li:before,ul.star li:before{float:left;padding-right:9pt;font-family:FontAwesome;color:#d9c6b1;font-size:14px}ul.caret li:before{content:\"\\F0DA\"}ul.circle li:before{content:\"\\F0A9\"}ul.circle li:before,ul.double-angle li:before{float:left;padding-right:9pt;font-family:FontAwesome;color:#d9c6b1;font-size:14px}ul.double-angle li:before{content:\"\\F101\"}@media screen and (min-width:1025px){#main-menu nav#navigation{display:block!important;height:auto!important;margin-top:-2px}.dotted-menu #main-menu{display:none}}@media (max-width:1024px){body.open{overflow:hidden}#home-content{padding:0}#menu-logo{display:block}#main-menu nav#navigation{display:none}#menu-logo{position:absolute;top:0;left:25px;height:56px;line-height:56px}#main-menu .container{width:100%}#main-menu #navigation{overflow-y:scroll}#main-menu{position:relative;overflow:hidden;line-height:inherit;padding-top:56px;height:auto;-webkit-transition:.3s all linear;transition:.3s all linear}#main-menu ul li a{font-size:14px}#main-menu nav#navigation li{display:block;padding:0 10px}#main-menu ul ul{display:block!important;position:relative;padding:0;margin-top:-10px}#main-menu ul ul li{line-height:56px;height:56px;text-align:center}#main-menu ul ul li a{line-height:56px;font-size:11px}#main-menu li.submenu:after{display:none}#menu-toggle-wrapper{display:block;top:0;right:0;position:absolute;width:75px;height:50px;z-index:111}#menu-toggle{display:block;top:30px;right:25px;width:25px;font-size:25px}#menu-toggle,#menu-toggle:before{position:absolute;height:2px;background:#ff8c89}#menu-toggle:before{content:'';right:0;width:100%;-webkit-transform-origin:center center;transform-origin:center center;top:-6px}#menu-toggle-wrapper.open #menu-toggle{-webkit-transform:rotate(45deg) translate(0, 0);transform:rotate(45deg) translate(0, 0)}#menu-toggle-wrapper.open #menu-toggle:before{-webkit-transform:rotate(90deg) translate(6px, 0);transform:rotate(90deg) translate(6px, 0)}#menu-toggle,#menu-toggle:before{-webkit-transition:all .3s cubic-bezier(0.585,-.6,.43,1.65);transition:all .3s cubic-bezier(0.585,-.6,.43,1.65)}}@media (max-width:668px){#logo{font:18px/5pc 'Playfair Display',serif}h1{font-size:28px}h2{font-size:26px;line-height:34px}#navigation-dotted{display:none}.section-tagline{max-width:88%}.hero h1{font-size:46px;line-height:52px}.hero #countdown{font-size:1pc;line-height:28px;padding:5px 0}.hero .info .date{font-size:1pc;bottom:5pc}#invitation a{padding:10px 35px}#couple .hero-heart{top:335px}.hero #countdown{display:none}#story .column{margin-bottom:60px;text-align:center}#important-people .arrow-down,#important-people .arrow-up,#important-people .timeline:before,#story .arrow-down,#story .arrow-up,#story .timeline:before,#twitter .arrow-down,#twitter .arrow-up,#twitter .timeline:before{display:none}#twitter .follow{margin-top:10px;margin-bottom:55px}#story .quote{font:18px/2pc 'Playfair Display',serif;margin:0 auto;padding:40px 20px}.timeline{padding-bottom:40px}#important-people,#twitter{padding-bottom:0}#wedding-events .timeline{padding-top:40px}.box{padding:25px}.box.center{padding:40px 25px}.timeline .left,.timeline .right{text-align:center}.date{text-align:right}.left .box.corner .date{right:35px}.timeline .column .box:after,.timeline .column.heart:after{display:none}.column.right{padding-right:0}.column.left{padding-left:0}.column.left,.column.right{clear:both;float:none}.timeline .movetop{margin-top:0}.timeline-year{margin-bottom:50px}#map-pins{display:none}.parallax h2.quote{font:24px/40px 'Playfair Display',serif}#wedding-gallery .container{width:100%}#gallery-filter>li{display:block;line-height:25px;border:none;margin:0;padding:0}#gallery-filter>li:after{content:none!important}#gallery-filter>li a{display:block;border-top:1px solid #efe7df;padding:8px 15px;border-radius:0!important;line-height:26px}#gallery-filter>li:first-child a{display:block;border-top:none}#gallery-filter .container{width:100%}#gallery-wrapper>div{width:50%}#gallery-wrapper .portfolio-title{font-size:9pt;line-height:18px}#instagram-section .hash{font-size:1pc}footer,footer .info{text-align:center}#page-content blockquote{font-size:1pc;line-height:24px}#background-image{height:420px}#title{height:auto;line-height:auto}#title .row{display:table;width:100%}#title .row .column.twelve{margin:15px 0}#title .six{float:none;margin-bottom:0;text-align:center;width:100%}#title .six,#title .three{display:table-cell;vertical-align:middle;height:100%}#title .three{width:10%}#title h1{font:28px/47px 'Playfair Display',serif;display:block;margin-bottom:0}.next,.prev{font-size:0}.box.quote{padding:40px}blockquote,q{font-size:1pc;line-height:26px}.baby#background-image{padding:30px 0}.baby .hero-inner h1{font-size:4pc;line-height:86px}.baby .hero-inner{vertical-align:middle}.baby .hero-inner>span{font-size:18px}.baby .hero-inner .date{font:21px/28px 'Playfair Display',serif}}", ""]);
	
	// exports


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5b8b7075f52f9e4ea006c9aae2668677.jpg";

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ef687b172a835659b9951ecafa09cfd.eot";

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2ef687b172a835659b9951ecafa09cfd.eot";

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(12);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./flaticon.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./flaticon.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(13);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./font-awesome.min.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./font-awesome.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(14);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./grid.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./grid.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(15);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./magnific-popup.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./magnific-popup.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(16);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./style-my.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./style-my.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(17);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI4ZWEzYTkzYzYxMjE0MGM2N2U4YjQxMzY4YzYzZWZkMy5zdmciOw=="

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI3NzZkNThmNDUzYzhmZTVkNmE4OWU5YzMxZWUyMjNmZi5zdmciOw=="

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/